import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminBillingDashboardMorningWorklist: build.query<
      GetV2AdminBillingDashboardMorningWorklistApiResponse,
      GetV2AdminBillingDashboardMorningWorklistApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/billing/dashboard/morning-worklist`,
        params: {
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          sort_dir: queryArg.sortDir,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2AdminBillingDashboardMorningWorklistHiddenOrganizations: build.query<
      GetV2AdminBillingDashboardMorningWorklistHiddenOrganizationsApiResponse,
      GetV2AdminBillingDashboardMorningWorklistHiddenOrganizationsApiArg
    >({
      query: () => ({
        url: `/v2/admin/billing/dashboard/morning-worklist/hidden-organizations`,
      }),
    }),
    postV2AdminBillingDashboardMorningWorklistHiddenOrganizations:
      build.mutation<
        PostV2AdminBillingDashboardMorningWorklistHiddenOrganizationsApiResponse,
        PostV2AdminBillingDashboardMorningWorklistHiddenOrganizationsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/billing/dashboard/morning-worklist/hidden-organizations`,
          method: "POST",
          body: queryArg.hideMorningWorklistOrganizationRequest,
        }),
      }),
    deleteV2AdminBillingDashboardMorningWorklistHiddenOrganizationsByOrganizationId:
      build.mutation<
        DeleteV2AdminBillingDashboardMorningWorklistHiddenOrganizationsByOrganizationIdApiResponse,
        DeleteV2AdminBillingDashboardMorningWorklistHiddenOrganizationsByOrganizationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/billing/dashboard/morning-worklist/hidden-organizations/${queryArg.organizationId}`,
          method: "DELETE",
        }),
      }),
    getV2AdminBillingDashboardOrganizations: build.query<
      GetV2AdminBillingDashboardOrganizationsApiResponse,
      GetV2AdminBillingDashboardOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/billing/dashboard/organizations`,
        params: {
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          sort_dir: queryArg.sortDir,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2AdminBillingDashboardOrganizationsByOrganizationId: build.query<
      GetV2AdminBillingDashboardOrganizationsByOrganizationIdApiResponse,
      GetV2AdminBillingDashboardOrganizationsByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/billing/dashboard/organizations/${queryArg.organizationId}`,
      }),
    }),
    getV2AdminBillingDashboardRcmScoreboard: build.query<
      GetV2AdminBillingDashboardRcmScoreboardApiResponse,
      GetV2AdminBillingDashboardRcmScoreboardApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/billing/dashboard/rcm-scoreboard`,
        params: {
          period: queryArg.period,
          period_start: queryArg.periodStart,
          period_end: queryArg.periodEnd,
          target_claims_paid_cents: queryArg.targetClaimsPaidCents,
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          sort_dir: queryArg.sortDir,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2AdminBillingDashboardSalesScoreboard: build.query<
      GetV2AdminBillingDashboardSalesScoreboardApiResponse,
      GetV2AdminBillingDashboardSalesScoreboardApiArg
    >({
      query: () => ({ url: `/v2/admin/billing/dashboard/sales-scoreboard` }),
    }),
    postV2AdminClaimRulesSeed: build.mutation<
      PostV2AdminClaimRulesSeedApiResponse,
      PostV2AdminClaimRulesSeedApiArg
    >({
      query: () => ({ url: `/v2/admin/claim-rules/seed`, method: "POST" }),
    }),
    getV2AdminClaimsByClaimIdReadiness: build.query<
      GetV2AdminClaimsByClaimIdReadinessApiResponse,
      GetV2AdminClaimsByClaimIdReadinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/claims/${queryArg.claimId}/readiness`,
      }),
    }),
    getV2AdminOrgsByOrganizationIdBillingEntities: build.query<
      GetV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse,
      GetV2AdminOrgsByOrganizationIdBillingEntitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdBillingEntities: build.mutation<
      PostV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse,
      PostV2AdminOrgsByOrganizationIdBillingEntitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities`,
        method: "POST",
        body: queryArg.createBillingEntityRequest,
      }),
    }),
    deleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityId:
      build.mutation<
        DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse,
        DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}`,
          method: "DELETE",
        }),
      }),
    getV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityId:
      build.query<
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse,
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}`,
        }),
      }),
    putV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityId:
      build.mutation<
        PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse,
        PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}`,
          method: "PUT",
          body: queryArg.updateBillingEntityRequest,
        }),
      }),
    getV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadiness:
      build.query<
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadinessApiResponse,
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadinessApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}/payers/${queryArg.payerId}/readiness`,
        }),
      }),
    postV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefault:
      build.mutation<
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiResponse,
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}/set-default`,
          method: "POST",
        }),
      }),
    postV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStedi:
      build.mutation<
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiResponse,
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}/sync-to-stedi`,
          method: "POST",
        }),
      }),
    getV2AdminOrgsByOrganizationIdBillingReadiness: build.query<
      GetV2AdminOrgsByOrganizationIdBillingReadinessApiResponse,
      GetV2AdminOrgsByOrganizationIdBillingReadinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing-readiness`,
      }),
    }),
    getV2AdminOrgsByOrganizationIdBillingPayerDocs: build.query<
      GetV2AdminOrgsByOrganizationIdBillingPayerDocsApiResponse,
      GetV2AdminOrgsByOrganizationIdBillingPayerDocsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing/payer-docs`,
      }),
    }),
    getV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKey: build.query<
      GetV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiResponse,
      GetV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing/payer-docs/${queryArg.payerKey}`,
      }),
    }),
    putV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKey: build.mutation<
      PutV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiResponse,
      PutV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing/payer-docs/${queryArg.payerKey}`,
        method: "PUT",
        body: queryArg.payerDocUpsertRequest,
      }),
    }),
    getV2AdminOrgsByOrganizationIdEnrollments: build.query<
      GetV2AdminOrgsByOrganizationIdEnrollmentsApiResponse,
      GetV2AdminOrgsByOrganizationIdEnrollmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdEnrollments: build.mutation<
      PostV2AdminOrgsByOrganizationIdEnrollmentsApiResponse,
      PostV2AdminOrgsByOrganizationIdEnrollmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments`,
        method: "POST",
        body: queryArg.initiateEnrollmentRequest,
      }),
    }),
    postV2AdminOrgsByOrganizationIdEnrollmentsSyncAll: build.mutation<
      PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiResponse,
      PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/sync-all`,
        method: "POST",
      }),
    }),
    getV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentId: build.query<
      GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiResponse,
      GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/${queryArg.enrollmentId}`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSync:
      build.mutation<
        PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiResponse,
        PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/${queryArg.enrollmentId}/sync`,
          method: "POST",
        }),
      }),
    getV2AdminOrgsByOrganizationIdJotbillFeeInvoices: build.query<
      GetV2AdminOrgsByOrganizationIdJotbillFeeInvoicesApiResponse,
      GetV2AdminOrgsByOrganizationIdJotbillFeeInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/jotbill-fee-invoices`,
      }),
    }),
    getV2AdminOrgsByOrganizationIdJotbillFeeInvoicesAndInvoiceId: build.query<
      GetV2AdminOrgsByOrganizationIdJotbillFeeInvoicesAndInvoiceIdApiResponse,
      GetV2AdminOrgsByOrganizationIdJotbillFeeInvoicesAndInvoiceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/jotbill-fee-invoices/${queryArg.invoiceId}`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdJotbillFeeRuns: build.mutation<
      PostV2AdminOrgsByOrganizationIdJotbillFeeRunsApiResponse,
      PostV2AdminOrgsByOrganizationIdJotbillFeeRunsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/jotbill-fee-runs`,
        method: "POST",
        body: queryArg.runJotBillFeeBillingRequest,
      }),
    }),
    getV2AdminOrgsByOrganizationIdJotbillTakeConfig: build.query<
      GetV2AdminOrgsByOrganizationIdJotbillTakeConfigApiResponse,
      GetV2AdminOrgsByOrganizationIdJotbillTakeConfigApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/jotbill-take-config`,
      }),
    }),
    patchV2AdminOrgsByOrganizationIdJotbillTakeConfig: build.mutation<
      PatchV2AdminOrgsByOrganizationIdJotbillTakeConfigApiResponse,
      PatchV2AdminOrgsByOrganizationIdJotbillTakeConfigApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/jotbill-take-config`,
        method: "PATCH",
        body: queryArg.updateJotBillTakeConfigRequest,
      }),
    }),
    getV2AdminOrgsByOrganizationIdRemittances: build.query<
      GetV2AdminOrgsByOrganizationIdRemittancesApiResponse,
      GetV2AdminOrgsByOrganizationIdRemittancesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/remittances`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
        },
      }),
    }),
    getV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummary:
      build.query<
        GetV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummaryApiResponse,
        GetV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/remittances/claims/${queryArg.claimId}/summary`,
        }),
      }),
    getV2AdminOrgsByOrganizationIdRemittancesAndRemittanceId: build.query<
      GetV2AdminOrgsByOrganizationIdRemittancesAndRemittanceIdApiResponse,
      GetV2AdminOrgsByOrganizationIdRemittancesAndRemittanceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/remittances/${queryArg.remittanceId}`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdStediConnect: build.mutation<
      PostV2AdminOrgsByOrganizationIdStediConnectApiResponse,
      PostV2AdminOrgsByOrganizationIdStediConnectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/connect`,
        method: "POST",
        body: queryArg.connectStediRequest,
      }),
    }),
    deleteV2AdminOrgsByOrganizationIdStediDisconnect: build.mutation<
      DeleteV2AdminOrgsByOrganizationIdStediDisconnectApiResponse,
      DeleteV2AdminOrgsByOrganizationIdStediDisconnectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/disconnect`,
        method: "DELETE",
      }),
    }),
    getV2AdminOrgsByOrganizationIdStediStatus: build.query<
      GetV2AdminOrgsByOrganizationIdStediStatusApiResponse,
      GetV2AdminOrgsByOrganizationIdStediStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/status`,
      }),
    }),
    getV2AdminOrgsByOrganizationIdStediTransactions: build.query<
      GetV2AdminOrgsByOrganizationIdStediTransactionsApiResponse,
      GetV2AdminOrgsByOrganizationIdStediTransactionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/transactions`,
        params: {
          page_size: queryArg.pageSize,
          page_token: queryArg.pageToken,
          from_date: queryArg.fromDate,
          to_date: queryArg.toDate,
          direction: queryArg.direction,
          mode: queryArg.mode,
          status: queryArg.status,
          transaction_set_id: queryArg.transactionSetId,
        },
      }),
    }),
    getV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionId:
      build.query<
        GetV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionIdApiResponse,
        GetV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/transactions/${queryArg.transactionId}`,
        }),
      }),
    postV2AdminOrgsByOrganizationIdStediVerify: build.mutation<
      PostV2AdminOrgsByOrganizationIdStediVerifyApiResponse,
      PostV2AdminOrgsByOrganizationIdStediVerifyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/verify`,
        method: "POST",
      }),
    }),
    postV2AdminPayersSync: build.mutation<
      PostV2AdminPayersSyncApiResponse,
      PostV2AdminPayersSyncApiArg
    >({
      query: () => ({ url: `/v2/admin/payers/sync`, method: "POST" }),
    }),
    getV2AdminPayersSyncStatus: build.query<
      GetV2AdminPayersSyncStatusApiResponse,
      GetV2AdminPayersSyncStatusApiArg
    >({
      query: () => ({ url: `/v2/admin/payers/sync-status` }),
    }),
    getV2ProviderBillingEntities: build.query<
      GetV2ProviderBillingEntitiesApiResponse,
      GetV2ProviderBillingEntitiesApiArg
    >({
      query: () => ({ url: `/v2/provider/billing-entities` }),
    }),
    postV2ProviderBillingEntities: build.mutation<
      PostV2ProviderBillingEntitiesApiResponse,
      PostV2ProviderBillingEntitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities`,
        method: "POST",
        body: queryArg.createBillingEntityRequest,
      }),
    }),
    deleteV2ProviderBillingEntitiesByBillingEntityId: build.mutation<
      DeleteV2ProviderBillingEntitiesByBillingEntityIdApiResponse,
      DeleteV2ProviderBillingEntitiesByBillingEntityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderBillingEntitiesByBillingEntityId: build.query<
      GetV2ProviderBillingEntitiesByBillingEntityIdApiResponse,
      GetV2ProviderBillingEntitiesByBillingEntityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}`,
      }),
    }),
    putV2ProviderBillingEntitiesByBillingEntityId: build.mutation<
      PutV2ProviderBillingEntitiesByBillingEntityIdApiResponse,
      PutV2ProviderBillingEntitiesByBillingEntityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}`,
        method: "PUT",
        body: queryArg.updateBillingEntityRequest,
      }),
    }),
    postV2ProviderBillingEntitiesByBillingEntityIdSetDefault: build.mutation<
      PostV2ProviderBillingEntitiesByBillingEntityIdSetDefaultApiResponse,
      PostV2ProviderBillingEntitiesByBillingEntityIdSetDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}/set-default`,
        method: "POST",
      }),
    }),
    postV2ProviderBillingEntitiesByBillingEntityIdSyncToStedi: build.mutation<
      PostV2ProviderBillingEntitiesByBillingEntityIdSyncToStediApiResponse,
      PostV2ProviderBillingEntitiesByBillingEntityIdSyncToStediApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}/sync-to-stedi`,
        method: "POST",
      }),
    }),
    getV2ProviderBillingMigrationSessions: build.query<
      GetV2ProviderBillingMigrationSessionsApiResponse,
      GetV2ProviderBillingMigrationSessionsApiArg
    >({
      query: () => ({ url: `/v2/provider/billing-migration/sessions` }),
    }),
    deleteV2ProviderBillingMigrationSessionsBySessionId: build.mutation<
      DeleteV2ProviderBillingMigrationSessionsBySessionIdApiResponse,
      DeleteV2ProviderBillingMigrationSessionsBySessionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-migration/sessions/${queryArg.sessionId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderBillingMigrationSessionsBySessionId: build.query<
      GetV2ProviderBillingMigrationSessionsBySessionIdApiResponse,
      GetV2ProviderBillingMigrationSessionsBySessionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-migration/sessions/${queryArg.sessionId}`,
      }),
    }),
    postV2ProviderBillingMigrationSessionsBySessionIdConfirm: build.mutation<
      PostV2ProviderBillingMigrationSessionsBySessionIdConfirmApiResponse,
      PostV2ProviderBillingMigrationSessionsBySessionIdConfirmApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-migration/sessions/${queryArg.sessionId}/confirm`,
        method: "POST",
      }),
    }),
    postV2ProviderBillingMigrationUpload: build.mutation<
      PostV2ProviderBillingMigrationUploadApiResponse,
      PostV2ProviderBillingMigrationUploadApiArg
    >({
      query: () => ({
        url: `/v2/provider/billing-migration/upload`,
        method: "POST",
      }),
    }),
    getV2ProviderBillingReadinessBillingEntitiesByBillingEntityIdPayersAndPayerId:
      build.query<
        GetV2ProviderBillingReadinessBillingEntitiesByBillingEntityIdPayersAndPayerIdApiResponse,
        GetV2ProviderBillingReadinessBillingEntitiesByBillingEntityIdPayersAndPayerIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/billing-readiness/billing-entities/${queryArg.billingEntityId}/payers/${queryArg.payerId}`,
        }),
      }),
    getV2ProviderBillingReadinessOrg: build.query<
      GetV2ProviderBillingReadinessOrgApiResponse,
      GetV2ProviderBillingReadinessOrgApiArg
    >({
      query: () => ({ url: `/v2/provider/billing-readiness/org` }),
    }),
    postV2ProviderBillingCharges: build.mutation<
      PostV2ProviderBillingChargesApiResponse,
      PostV2ProviderBillingChargesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/charges`,
        method: "POST",
        body: queryArg.captureChargesRequest,
      }),
    }),
    getV2ProviderBillingClaims: build.query<
      GetV2ProviderBillingClaimsApiResponse,
      GetV2ProviderBillingClaimsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/claims`,
        params: {
          patient_id: queryArg.patientId,
          provider_ids: queryArg.providerIds,
          status: queryArg.status,
          payer_uuid: queryArg.payerUuid,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          submission_date_from: queryArg.submissionDateFrom,
          submission_date_to: queryArg.submissionDateTo,
          charge_min: queryArg.chargeMin,
          charge_max: queryArg.chargeMax,
          balance_min: queryArg.balanceMin,
          balance_max: queryArg.balanceMax,
          source_system: queryArg.sourceSystem,
          claim_type: queryArg.claimType,
          queue: queryArg.queue,
          include_superseded: queryArg.includeSuperseded,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderBillingClaimsQueueCounts: build.query<
      GetV2ProviderBillingClaimsQueueCountsApiResponse,
      GetV2ProviderBillingClaimsQueueCountsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/claims/queue-counts`,
        params: {
          patient_id: queryArg.patientId,
          provider_ids: queryArg.providerIds,
          status: queryArg.status,
          payer_uuid: queryArg.payerUuid,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          submission_date_from: queryArg.submissionDateFrom,
          submission_date_to: queryArg.submissionDateTo,
          charge_min: queryArg.chargeMin,
          charge_max: queryArg.chargeMax,
          balance_min: queryArg.balanceMin,
          balance_max: queryArg.balanceMax,
          source_system: queryArg.sourceSystem,
          claim_type: queryArg.claimType,
          queue: queryArg.queue,
          include_superseded: queryArg.includeSuperseded,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderBillingClaimsByClaimId: build.query<
      GetV2ProviderBillingClaimsByClaimIdApiResponse,
      GetV2ProviderBillingClaimsByClaimIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/claims/${queryArg.claimId}`,
      }),
    }),
    postV2ProviderBillingCptChargesLookup: build.mutation<
      PostV2ProviderBillingCptChargesLookupApiResponse,
      PostV2ProviderBillingCptChargesLookupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/cpt-charges/lookup`,
        method: "POST",
        body: queryArg.cptChargesLookupRequest,
      }),
    }),
    getV2ProviderBillingCptChargesByCptCode: build.query<
      GetV2ProviderBillingCptChargesByCptCodeApiResponse,
      GetV2ProviderBillingCptChargesByCptCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/cpt-charges/${queryArg.cptCode}`,
      }),
    }),
    getV2ProviderBillingEncounters: build.query<
      GetV2ProviderBillingEncountersApiResponse,
      GetV2ProviderBillingEncountersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters`,
        params: {
          patient_id: queryArg.patientId,
          provider_ids: queryArg.providerIds,
          status: queryArg.status,
          billable: queryArg.billable,
          has_claim: queryArg.hasClaim,
          ready_to_bill: queryArg.readyToBill,
          payer_uuid: queryArg.payerUuid,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderBillingEncountersUnifiedWorklist: build.query<
      GetV2ProviderBillingEncountersUnifiedWorklistApiResponse,
      GetV2ProviderBillingEncountersUnifiedWorklistApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/unified-worklist`,
        params: {
          work_state: queryArg.workState,
          stage: queryArg.stage,
          patient_id: queryArg.patientId,
          provider_ids: queryArg.providerIds,
          payer_uuid: queryArg.payerUuid,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          owner: queryArg.owner,
          severity: queryArg.severity,
          has_claim: queryArg.hasClaim,
          bill_with_jotpsych: queryArg.billWithJotpsych,
          stale_only: queryArg.staleOnly,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderBillingEncountersByEncounterId: build.query<
      GetV2ProviderBillingEncountersByEncounterIdApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}`,
      }),
    }),
    getV2ProviderBillingEncountersByEncounterIdClaimWorkspace: build.query<
      GetV2ProviderBillingEncountersByEncounterIdClaimWorkspaceApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdClaimWorkspaceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}/claim-workspace`,
        params: {
          claim_id: queryArg.claimId,
        },
      }),
    }),
    postV2ProviderBillingEncountersByEncounterIdClaimWorkspaceRefresh:
      build.mutation<
        PostV2ProviderBillingEncountersByEncounterIdClaimWorkspaceRefreshApiResponse,
        PostV2ProviderBillingEncountersByEncounterIdClaimWorkspaceRefreshApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/billing/encounters/${queryArg.encounterId}/claim-workspace/refresh`,
          method: "POST",
          body: queryArg.unifiedEncounterClaimWorkspaceRefreshRequest,
        }),
      }),
    getV2ProviderBillingEncountersByEncounterIdFlow: build.query<
      GetV2ProviderBillingEncountersByEncounterIdFlowApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdFlowApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}/flow`,
      }),
    }),
    getV2ProviderBillingEncountersByEncounterIdOverview: build.query<
      GetV2ProviderBillingEncountersByEncounterIdOverviewApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}/overview`,
      }),
    }),
    getV2ProviderBillingEncountersByEncounterIdPayments: build.query<
      GetV2ProviderBillingEncountersByEncounterIdPaymentsApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdPaymentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}/payments`,
      }),
    }),
    getV2ProviderBillingEncountersByEncounterIdReadiness: build.query<
      GetV2ProviderBillingEncountersByEncounterIdReadinessApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdReadinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}/readiness`,
      }),
    }),
    getV2ProviderBillingEncountersByEncounterIdUnified: build.query<
      GetV2ProviderBillingEncountersByEncounterIdUnifiedApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdUnifiedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}/unified`,
      }),
    }),
    getV2ProviderBillingFeeSchedulesBaseline: build.query<
      GetV2ProviderBillingFeeSchedulesBaselineApiResponse,
      GetV2ProviderBillingFeeSchedulesBaselineApiArg
    >({
      query: () => ({ url: `/v2/provider/billing/fee-schedules/baseline` }),
    }),
    putV2ProviderBillingFeeSchedulesBaseline: build.mutation<
      PutV2ProviderBillingFeeSchedulesBaselineApiResponse,
      PutV2ProviderBillingFeeSchedulesBaselineApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/fee-schedules/baseline`,
        method: "PUT",
        body: queryArg.baselineRatesUpsertRequest,
      }),
    }),
    deleteV2ProviderBillingFeeSchedulesBaselineByCodeId: build.mutation<
      DeleteV2ProviderBillingFeeSchedulesBaselineByCodeIdApiResponse,
      DeleteV2ProviderBillingFeeSchedulesBaselineByCodeIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/fee-schedules/baseline/${queryArg.codeId}`,
        method: "DELETE",
      }),
    }),
    postV2ProviderBillingFeeSchedulesFromExtraction: build.mutation<
      PostV2ProviderBillingFeeSchedulesFromExtractionApiResponse,
      PostV2ProviderBillingFeeSchedulesFromExtractionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/fee-schedules/from-extraction`,
        method: "POST",
        body: queryArg.feeScheduleImportRequest,
      }),
    }),
    getV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRates: build.query<
      GetV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRatesApiResponse,
      GetV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/fee-schedules/payers/${queryArg.payerId}/expected-rates`,
      }),
    }),
    putV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRates:
      build.mutation<
        PutV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRatesApiResponse,
        PutV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRatesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/billing/fee-schedules/payers/${queryArg.payerId}/expected-rates`,
          method: "PUT",
          body: queryArg.payerExpectedRatesUpsertRequest,
        }),
      }),
    deleteV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRatesAndCodeId:
      build.mutation<
        DeleteV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRatesAndCodeIdApiResponse,
        DeleteV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRatesAndCodeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/billing/fee-schedules/payers/${queryArg.payerId}/expected-rates/${queryArg.codeId}`,
          method: "DELETE",
        }),
      }),
    getV2ProviderBillingInvoices: build.query<
      GetV2ProviderBillingInvoicesApiResponse,
      GetV2ProviderBillingInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/invoices`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
          status: queryArg.status,
          patient_id: queryArg.patientId,
        },
      }),
    }),
    getV2ProviderBillingPatientsByPatientIdBalance: build.query<
      GetV2ProviderBillingPatientsByPatientIdBalanceApiResponse,
      GetV2ProviderBillingPatientsByPatientIdBalanceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/patients/${queryArg.patientId}/balance`,
        params: {
          encounter_id: queryArg.encounterId,
          party_type: queryArg.partyType,
          entry_type: queryArg.entryType,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    postV2ProviderBillingPatientsByPatientIdPayments: build.mutation<
      PostV2ProviderBillingPatientsByPatientIdPaymentsApiResponse,
      PostV2ProviderBillingPatientsByPatientIdPaymentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/patients/${queryArg.patientId}/payments`,
        method: "POST",
        body: queryArg.recordPaymentRequest,
      }),
    }),
    postV2ProviderBillingPatientsByPatientIdWriteOffs: build.mutation<
      PostV2ProviderBillingPatientsByPatientIdWriteOffsApiResponse,
      PostV2ProviderBillingPatientsByPatientIdWriteOffsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/patients/${queryArg.patientId}/write-offs`,
        method: "POST",
        body: queryArg.writeOffRequest,
      }),
    }),
    getV2ProviderBillingPayerDocs: build.query<
      GetV2ProviderBillingPayerDocsApiResponse,
      GetV2ProviderBillingPayerDocsApiArg
    >({
      query: () => ({ url: `/v2/provider/billing/payer-docs` }),
    }),
    getV2ProviderBillingPayerDocsByPayerKey: build.query<
      GetV2ProviderBillingPayerDocsByPayerKeyApiResponse,
      GetV2ProviderBillingPayerDocsByPayerKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/payer-docs/${queryArg.payerKey}`,
      }),
    }),
    putV2ProviderBillingPayerDocsByPayerKey: build.mutation<
      PutV2ProviderBillingPayerDocsByPayerKeyApiResponse,
      PutV2ProviderBillingPayerDocsByPayerKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/payer-docs/${queryArg.payerKey}`,
        method: "PUT",
        body: queryArg.payerDocUpsertRequest,
      }),
    }),
    getV2ProviderBillingRemittances: build.query<
      GetV2ProviderBillingRemittancesApiResponse,
      GetV2ProviderBillingRemittancesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/remittances`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          payer_name: queryArg.payerName,
          payment_method: queryArg.paymentMethod,
          source_system: queryArg.sourceSystem,
          amount_min: queryArg.amountMin,
          amount_max: queryArg.amountMax,
          queue: queryArg.queue,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    getV2ProviderBillingRemittancesClaimsByClaimIdSummary: build.query<
      GetV2ProviderBillingRemittancesClaimsByClaimIdSummaryApiResponse,
      GetV2ProviderBillingRemittancesClaimsByClaimIdSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/remittances/claims/${queryArg.claimId}/summary`,
      }),
    }),
    getV2ProviderBillingRemittancesQueueCounts: build.query<
      GetV2ProviderBillingRemittancesQueueCountsApiResponse,
      GetV2ProviderBillingRemittancesQueueCountsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/remittances/queue-counts`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          payer_name: queryArg.payerName,
          payment_method: queryArg.paymentMethod,
          source_system: queryArg.sourceSystem,
          amount_min: queryArg.amountMin,
          amount_max: queryArg.amountMax,
          queue: queryArg.queue,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    getV2ProviderBillingRemittancesByRemittanceId: build.query<
      GetV2ProviderBillingRemittancesByRemittanceIdApiResponse,
      GetV2ProviderBillingRemittancesByRemittanceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/remittances/${queryArg.remittanceId}`,
      }),
    }),
    getV2ProviderBillingStatementsHistory: build.query<
      GetV2ProviderBillingStatementsHistoryApiResponse,
      GetV2ProviderBillingStatementsHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/statements/history`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          trigger_type: queryArg.triggerType,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
        },
      }),
    }),
    getV2ProviderBillingStatementsQueue: build.query<
      GetV2ProviderBillingStatementsQueueApiResponse,
      GetV2ProviderBillingStatementsQueueApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/statements/queue`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    putV2ProviderEncountersByEncounterIdWorkingBillingClaim: build.mutation<
      PutV2ProviderEncountersByEncounterIdWorkingBillingClaimApiResponse,
      PutV2ProviderEncountersByEncounterIdWorkingBillingClaimApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/working-billing-claim`,
        method: "PUT",
        body: queryArg.workingBillingClaimPutRequest,
      }),
    }),
    getV2ProviderEnrollments: build.query<
      GetV2ProviderEnrollmentsApiResponse,
      GetV2ProviderEnrollmentsApiArg
    >({
      query: () => ({ url: `/v2/provider/enrollments` }),
    }),
    postV2ProviderEnrollments: build.mutation<
      PostV2ProviderEnrollmentsApiResponse,
      PostV2ProviderEnrollmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments`,
        method: "POST",
        body: queryArg.initiateEnrollmentRequest,
      }),
    }),
    postV2ProviderEnrollmentsSyncAll: build.mutation<
      PostV2ProviderEnrollmentsSyncAllApiResponse,
      PostV2ProviderEnrollmentsSyncAllApiArg
    >({
      query: () => ({
        url: `/v2/provider/enrollments/sync-all`,
        method: "POST",
      }),
    }),
    getV2ProviderEnrollmentsByEnrollmentId: build.query<
      GetV2ProviderEnrollmentsByEnrollmentIdApiResponse,
      GetV2ProviderEnrollmentsByEnrollmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments/${queryArg.enrollmentId}`,
      }),
    }),
    postV2ProviderEnrollmentsByEnrollmentIdDocuments: build.mutation<
      PostV2ProviderEnrollmentsByEnrollmentIdDocumentsApiResponse,
      PostV2ProviderEnrollmentsByEnrollmentIdDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments/${queryArg.enrollmentId}/documents`,
        method: "POST",
        body: queryArg.uploadDocumentRequest,
      }),
    }),
    postV2ProviderEnrollmentsByEnrollmentIdSync: build.mutation<
      PostV2ProviderEnrollmentsByEnrollmentIdSyncApiResponse,
      PostV2ProviderEnrollmentsByEnrollmentIdSyncApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments/${queryArg.enrollmentId}/sync`,
        method: "POST",
      }),
    }),
    postV2ProviderEnrollmentsByEnrollmentIdTasksAndTaskId: build.mutation<
      PostV2ProviderEnrollmentsByEnrollmentIdTasksAndTaskIdApiResponse,
      PostV2ProviderEnrollmentsByEnrollmentIdTasksAndTaskIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments/${queryArg.enrollmentId}/tasks/${queryArg.taskId}`,
        method: "POST",
        body: queryArg.completeTaskRequest,
      }),
    }),
    getV2ProviderServiceFacilities: build.query<
      GetV2ProviderServiceFacilitiesApiResponse,
      GetV2ProviderServiceFacilitiesApiArg
    >({
      query: () => ({ url: `/v2/provider/service-facilities` }),
    }),
    postV2ProviderServiceFacilities: build.mutation<
      PostV2ProviderServiceFacilitiesApiResponse,
      PostV2ProviderServiceFacilitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/service-facilities`,
        method: "POST",
        body: queryArg.createServiceFacilityRequest,
      }),
    }),
    deleteV2ProviderServiceFacilitiesByServiceFacilityId: build.mutation<
      DeleteV2ProviderServiceFacilitiesByServiceFacilityIdApiResponse,
      DeleteV2ProviderServiceFacilitiesByServiceFacilityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/service-facilities/${queryArg.serviceFacilityId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderServiceFacilitiesByServiceFacilityId: build.query<
      GetV2ProviderServiceFacilitiesByServiceFacilityIdApiResponse,
      GetV2ProviderServiceFacilitiesByServiceFacilityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/service-facilities/${queryArg.serviceFacilityId}`,
      }),
    }),
    putV2ProviderServiceFacilitiesByServiceFacilityId: build.mutation<
      PutV2ProviderServiceFacilitiesByServiceFacilityIdApiResponse,
      PutV2ProviderServiceFacilitiesByServiceFacilityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/service-facilities/${queryArg.serviceFacilityId}`,
        method: "PUT",
        body: queryArg.updateServiceFacilityRequest,
      }),
    }),
    postV2ProviderServiceFacilitiesByServiceFacilityIdSetDefault:
      build.mutation<
        PostV2ProviderServiceFacilitiesByServiceFacilityIdSetDefaultApiResponse,
        PostV2ProviderServiceFacilitiesByServiceFacilityIdSetDefaultApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/service-facilities/${queryArg.serviceFacilityId}/set-default`,
          method: "POST",
        }),
      }),
    postV2ProviderStediConnect: build.mutation<
      PostV2ProviderStediConnectApiResponse,
      PostV2ProviderStediConnectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/stedi/connect`,
        method: "POST",
        body: queryArg.connectStediRequest,
      }),
    }),
    deleteV2ProviderStediDisconnect: build.mutation<
      DeleteV2ProviderStediDisconnectApiResponse,
      DeleteV2ProviderStediDisconnectApiArg
    >({
      query: () => ({ url: `/v2/provider/stedi/disconnect`, method: "DELETE" }),
    }),
    getV2ProviderStediStatus: build.query<
      GetV2ProviderStediStatusApiResponse,
      GetV2ProviderStediStatusApiArg
    >({
      query: () => ({ url: `/v2/provider/stedi/status` }),
    }),
    postV2ProviderStediVerify: build.mutation<
      PostV2ProviderStediVerifyApiResponse,
      PostV2ProviderStediVerifyApiArg
    >({
      query: () => ({ url: `/v2/provider/stedi/verify`, method: "POST" }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminBillingDashboardMorningWorklistApiResponse =
  /** status 200 OK */ MorningWorklistResponse;
export type GetV2AdminBillingDashboardMorningWorklistApiArg = {
  /** Search organizations by name */
  search?: string | null;
  /** Column to sort by */
  sortBy?: string;
  /** Sort direction: asc or desc */
  sortDir?: string;
  /** Page number */
  page?: number;
  /** Items per page (max 100) */
  perPage?: number;
};
export type GetV2AdminBillingDashboardMorningWorklistHiddenOrganizationsApiResponse =
  /** status 200 OK */ HiddenMorningWorklistOrganizationsResponse;
export type GetV2AdminBillingDashboardMorningWorklistHiddenOrganizationsApiArg =
  void;
export type PostV2AdminBillingDashboardMorningWorklistHiddenOrganizationsApiResponse =
  /** status 200 OK */ HiddenMorningWorklistOrganizationResponse2;
export type PostV2AdminBillingDashboardMorningWorklistHiddenOrganizationsApiArg =
  {
    hideMorningWorklistOrganizationRequest: HideMorningWorklistOrganizationRequest;
  };
export type DeleteV2AdminBillingDashboardMorningWorklistHiddenOrganizationsByOrganizationIdApiResponse =
  /** status 200 OK */ UnhideMorningWorklistOrganizationResponse;
export type DeleteV2AdminBillingDashboardMorningWorklistHiddenOrganizationsByOrganizationIdApiArg =
  {
    organizationId: string;
  };
export type GetV2AdminBillingDashboardOrganizationsApiResponse =
  /** status 200 OK */ OrganizationBillingListResponse;
export type GetV2AdminBillingDashboardOrganizationsApiArg = {
  /** Search organizations by name */
  search?: string | null;
  /** Column to sort by (e.g. claims_needs_attention, denial_rate_pct, oldest_draft_age_days) */
  sortBy?: string;
  /** Sort direction: asc or desc */
  sortDir?: string;
  /** Page number */
  page?: number;
  /** Items per page (max 100) */
  perPage?: number;
};
export type GetV2AdminBillingDashboardOrganizationsByOrganizationIdApiResponse =
  /** status 200 OK */ OrganizationBillingDetailResponse;
export type GetV2AdminBillingDashboardOrganizationsByOrganizationIdApiArg = {
  organizationId: string;
};
export type GetV2AdminBillingDashboardRcmScoreboardApiResponse =
  /** status 200 OK */ JuneRcmScoreboardResponse;
export type GetV2AdminBillingDashboardRcmScoreboardApiArg = {
  /** Date preset: month_to_date, this_month, last_30_days, last_90_days, all_time, or custom */
  period?: string;
  /** Custom inclusive start date in YYYY-MM-DD format */
  periodStart?: string | null;
  /** Custom inclusive end date in YYYY-MM-DD format */
  periodEnd?: string | null;
  /** Claims-paid target for progress calculation */
  targetClaimsPaidCents?: number;
  /** Search organizations by name */
  search?: string | null;
  /** Organization row column to sort by */
  sortBy?: string;
  /** Sort direction: asc or desc */
  sortDir?: string;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2AdminBillingDashboardSalesScoreboardApiResponse =
  /** status 200 OK */ SalesScoreboardResponse;
export type GetV2AdminBillingDashboardSalesScoreboardApiArg = void;
export type PostV2AdminClaimRulesSeedApiResponse =
  /** status 200 OK */ RuleSeedResponse;
export type PostV2AdminClaimRulesSeedApiArg = void;
export type GetV2AdminClaimsByClaimIdReadinessApiResponse =
  /** status 200 OK */ ClaimSubmissionReadinessResponse;
export type GetV2AdminClaimsByClaimIdReadinessApiArg = {
  claimId: string;
};
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityListResponse;
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesApiArg = {
  organizationId: string;
};
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesApiArg = {
  organizationId: string;
  createBillingEntityRequest: CreateBillingEntityRequest;
};
export type DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityDeleteResponse;
export type DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg =
  {
    organizationId: string;
    billingEntityId: string;
    updateBillingEntityRequest: UpdateBillingEntityRequest;
  };
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadinessApiResponse =
  /** status 200 OK */ PayerReadinessResponse;
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadinessApiArg =
  {
    organizationId: string;
    billingEntityId: string;
    payerId: string;
  };
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiResponse =
  /** status 200 OK */ SyncToStediResponse;
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type GetV2AdminOrgsByOrganizationIdBillingReadinessApiResponse =
  /** status 200 OK */ OrgBillingReadinessResponse;
export type GetV2AdminOrgsByOrganizationIdBillingReadinessApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdBillingPayerDocsApiResponse =
  /** status 200 OK */ PayerDocListResponse;
export type GetV2AdminOrgsByOrganizationIdBillingPayerDocsApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiResponse =
  /** status 200 OK */ PayerDocResponse2;
export type GetV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiArg = {
  organizationId: string;
  payerKey: string;
};
export type PutV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiResponse =
  /** status 200 OK */ PayerDocResponse2;
export type PutV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiArg = {
  organizationId: string;
  payerKey: string;
  payerDocUpsertRequest: PayerDocUpsertRequest;
};
export type GetV2AdminOrgsByOrganizationIdEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentListResponse;
export type GetV2AdminOrgsByOrganizationIdEnrollmentsApiArg = {
  organizationId: string;
};
export type PostV2AdminOrgsByOrganizationIdEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2AdminOrgsByOrganizationIdEnrollmentsApiArg = {
  organizationId: string;
  initiateEnrollmentRequest: InitiateEnrollmentRequest;
};
export type PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiResponse =
  /** status 200 OK */ SyncAllResponse;
export type PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiArg = {
  organizationId: string;
  enrollmentId: string;
};
export type PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiArg =
  {
    organizationId: string;
    enrollmentId: string;
  };
export type GetV2AdminOrgsByOrganizationIdJotbillFeeInvoicesApiResponse =
  /** status 200 OK */ JotBillFeeInvoiceListResponse;
export type GetV2AdminOrgsByOrganizationIdJotbillFeeInvoicesApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdJotbillFeeInvoicesAndInvoiceIdApiResponse =
  /** status 200 OK */ JotBillFeeInvoiceDetailResponse;
export type GetV2AdminOrgsByOrganizationIdJotbillFeeInvoicesAndInvoiceIdApiArg =
  {
    organizationId: string;
    invoiceId: string;
  };
export type PostV2AdminOrgsByOrganizationIdJotbillFeeRunsApiResponse =
  /** status 200 OK */ JotBillFeeRunResponse;
export type PostV2AdminOrgsByOrganizationIdJotbillFeeRunsApiArg = {
  organizationId: string;
  runJotBillFeeBillingRequest: RunJotBillFeeBillingRequest;
};
export type GetV2AdminOrgsByOrganizationIdJotbillTakeConfigApiResponse =
  /** status 200 OK */ JotBillTakeConfigResponse;
export type GetV2AdminOrgsByOrganizationIdJotbillTakeConfigApiArg = {
  organizationId: string;
};
export type PatchV2AdminOrgsByOrganizationIdJotbillTakeConfigApiResponse =
  /** status 200 OK */ JotBillTakeConfigResponse;
export type PatchV2AdminOrgsByOrganizationIdJotbillTakeConfigApiArg = {
  organizationId: string;
  updateJotBillTakeConfigRequest: UpdateJotBillTakeConfigRequest;
};
export type GetV2AdminOrgsByOrganizationIdRemittancesApiResponse =
  /** status 200 OK */ RemittanceListResponse;
export type GetV2AdminOrgsByOrganizationIdRemittancesApiArg = {
  organizationId: string;
  /** Page number (1-based) */
  page?: number;
  /** Number of items per page (max 100) */
  perPage?: number;
  /** Filter: earliest created_at date (YYYY-MM-DD) */
  dateFrom?: string | null;
  /** Filter: latest created_at date (YYYY-MM-DD) */
  dateTo?: string | null;
};
export type GetV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummaryApiResponse =
  /** status 200 OK */ ClaimRemittanceSummaryResponse;
export type GetV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummaryApiArg =
  {
    organizationId: string;
    claimId: string;
  };
export type GetV2AdminOrgsByOrganizationIdRemittancesAndRemittanceIdApiResponse =
  /** status 200 OK */ RemittanceDetailResponse;
export type GetV2AdminOrgsByOrganizationIdRemittancesAndRemittanceIdApiArg = {
  organizationId: string;
  remittanceId: string;
};
export type PostV2AdminOrgsByOrganizationIdStediConnectApiResponse =
  /** status 200 OK */ ConnectStediResponse;
export type PostV2AdminOrgsByOrganizationIdStediConnectApiArg = {
  organizationId: string;
  connectStediRequest: ConnectStediRequest;
};
export type DeleteV2AdminOrgsByOrganizationIdStediDisconnectApiResponse =
  /** status 200 OK */ DisconnectStediResponse;
export type DeleteV2AdminOrgsByOrganizationIdStediDisconnectApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdStediStatusApiResponse =
  /** status 200 OK */ StediConnectionStatusResponse;
export type GetV2AdminOrgsByOrganizationIdStediStatusApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdStediTransactionsApiResponse =
  /** status 200 OK */ StediTransactionListResponse;
export type GetV2AdminOrgsByOrganizationIdStediTransactionsApiArg = {
  organizationId: string;
  /** Results per page (1-500, default 100) */
  pageSize?: number | null;
  /** Cursor token from a previous response for pagination */
  pageToken?: string | null;
  /** ISO 8601 start of time range filter (e.g., 2026-02-01T00:00:00Z) */
  fromDate?: string | null;
  /** ISO 8601 end of time range filter */
  toDate?: string | null;
  /** Filter by direction: INBOUND, OUTBOUND, or UNKNOWN */
  direction?: string | null;
  /** Filter by mode: test, production, or other */
  mode?: string | null;
  /** Filter by status: failed or succeeded */
  status?: string | null;
  /** X12 transaction set code (e.g., 277, 835, 837) */
  transactionSetId?: string | null;
};
export type GetV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionIdApiResponse =
  /** status 200 OK */ StediTransactionDetailResponse;
export type GetV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionIdApiArg =
  {
    organizationId: string;
    transactionId: string;
  };
export type PostV2AdminOrgsByOrganizationIdStediVerifyApiResponse =
  /** status 200 OK */ VerifyStediResponse;
export type PostV2AdminOrgsByOrganizationIdStediVerifyApiArg = {
  organizationId: string;
};
export type PostV2AdminPayersSyncApiResponse =
  /** status 202 Accepted */ PayerSyncResponse;
export type PostV2AdminPayersSyncApiArg = void;
export type GetV2AdminPayersSyncStatusApiResponse =
  /** status 200 OK */ PayerSyncStatusResponse;
export type GetV2AdminPayersSyncStatusApiArg = void;
export type GetV2ProviderBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityListResponse;
export type GetV2ProviderBillingEntitiesApiArg = void;
export type PostV2ProviderBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2ProviderBillingEntitiesApiArg = {
  createBillingEntityRequest: CreateBillingEntityRequest;
};
export type DeleteV2ProviderBillingEntitiesByBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityDeleteResponse;
export type DeleteV2ProviderBillingEntitiesByBillingEntityIdApiArg = {
  billingEntityId: string;
};
export type GetV2ProviderBillingEntitiesByBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type GetV2ProviderBillingEntitiesByBillingEntityIdApiArg = {
  billingEntityId: string;
};
export type PutV2ProviderBillingEntitiesByBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PutV2ProviderBillingEntitiesByBillingEntityIdApiArg = {
  billingEntityId: string;
  updateBillingEntityRequest: UpdateBillingEntityRequest;
};
export type PostV2ProviderBillingEntitiesByBillingEntityIdSetDefaultApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2ProviderBillingEntitiesByBillingEntityIdSetDefaultApiArg = {
  billingEntityId: string;
};
export type PostV2ProviderBillingEntitiesByBillingEntityIdSyncToStediApiResponse =
  /** status 200 OK */ SyncToStediResponse;
export type PostV2ProviderBillingEntitiesByBillingEntityIdSyncToStediApiArg = {
  billingEntityId: string;
};
export type GetV2ProviderBillingMigrationSessionsApiResponse =
  /** status 200 OK */ BillingMigrationSessionListResponse;
export type GetV2ProviderBillingMigrationSessionsApiArg = void;
export type DeleteV2ProviderBillingMigrationSessionsBySessionIdApiResponse =
  /** status 200 OK */ BillingMigrationSessionResponse2;
export type DeleteV2ProviderBillingMigrationSessionsBySessionIdApiArg = {
  sessionId: string;
};
export type GetV2ProviderBillingMigrationSessionsBySessionIdApiResponse =
  /** status 200 OK */ BillingMigrationSessionResponse2;
export type GetV2ProviderBillingMigrationSessionsBySessionIdApiArg = {
  sessionId: string;
};
export type PostV2ProviderBillingMigrationSessionsBySessionIdConfirmApiResponse =
  /** status 200 OK */ BillingMigrationConfirmResponse;
export type PostV2ProviderBillingMigrationSessionsBySessionIdConfirmApiArg = {
  sessionId: string;
};
export type PostV2ProviderBillingMigrationUploadApiResponse =
  /** status 200 OK */ BillingMigrationUploadResponse;
export type PostV2ProviderBillingMigrationUploadApiArg = void;
export type GetV2ProviderBillingReadinessBillingEntitiesByBillingEntityIdPayersAndPayerIdApiResponse =
  /** status 200 OK */ PayerReadinessResponse;
export type GetV2ProviderBillingReadinessBillingEntitiesByBillingEntityIdPayersAndPayerIdApiArg =
  {
    billingEntityId: string;
    payerId: string;
  };
export type GetV2ProviderBillingReadinessOrgApiResponse =
  /** status 200 OK */ OrgBillingReadinessResponse;
export type GetV2ProviderBillingReadinessOrgApiArg = void;
export type PostV2ProviderBillingChargesApiResponse =
  /** status 201 Created */ CaptureChargesResponse;
export type PostV2ProviderBillingChargesApiArg = {
  captureChargesRequest: CaptureChargesRequest;
};
export type GetV2ProviderBillingClaimsApiResponse =
  /** status 200 OK */ OrgClaimListResponse;
export type GetV2ProviderBillingClaimsApiArg = {
  /** Filter by patient ID */
  patientId?: string | null;
  /** Comma-separated provider IDs to filter by */
  providerIds?: string | null;
  /** Filter by claim status (draft, processing, ready, submitted, acknowledged, accepted, rejected, paid, partially_paid, denied, reversed, imported) */
  status?: string | null;
  /** Filter by payer UUID */
  payerUuid?: string | null;
  /** Filter claims with service date from this date (ISO 8601) */
  dateFrom?: string | null;
  /** Filter claims with service date up to this date (ISO 8601) */
  dateTo?: string | null;
  /** Filter claims submitted from this date (ISO 8601) */
  submissionDateFrom?: string | null;
  /** Filter claims submitted up to this date (ISO 8601) */
  submissionDateTo?: string | null;
  /** Minimum total_charge_cents */
  chargeMin?: number | null;
  /** Maximum total_charge_cents */
  chargeMax?: number | null;
  /** Minimum balance_due_cents */
  balanceMin?: number | null;
  /** Maximum balance_due_cents */
  balanceMax?: number | null;
  /** Filter by source system (jotpsych, collabmd, etc.) */
  sourceSystem?: string | null;
  /** Filter by claim type (original, corrected, void) */
  claimType?: string | null;
  /** Smart queue filter (needs_attention, ready_to_submit, blocked, submitted, denied, paid, imported). Overrides status if both provided. */
  queue?: string | null;
  /** Include claims that have been superseded by a correction or void. Default hides superseded claims. */
  includeSuperseded?: boolean;
  /** Field to sort by (created_at, service_date_from, total_charge_cents) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2ProviderBillingClaimsQueueCountsApiResponse =
  /** status 200 OK */ ClaimQueueCounts;
export type GetV2ProviderBillingClaimsQueueCountsApiArg = {
  /** Filter by patient ID */
  patientId?: string | null;
  /** Comma-separated provider IDs to filter by */
  providerIds?: string | null;
  /** Filter by claim status (draft, processing, ready, submitted, acknowledged, accepted, rejected, paid, partially_paid, denied, reversed, imported) */
  status?: string | null;
  /** Filter by payer UUID */
  payerUuid?: string | null;
  /** Filter claims with service date from this date (ISO 8601) */
  dateFrom?: string | null;
  /** Filter claims with service date up to this date (ISO 8601) */
  dateTo?: string | null;
  /** Filter claims submitted from this date (ISO 8601) */
  submissionDateFrom?: string | null;
  /** Filter claims submitted up to this date (ISO 8601) */
  submissionDateTo?: string | null;
  /** Minimum total_charge_cents */
  chargeMin?: number | null;
  /** Maximum total_charge_cents */
  chargeMax?: number | null;
  /** Minimum balance_due_cents */
  balanceMin?: number | null;
  /** Maximum balance_due_cents */
  balanceMax?: number | null;
  /** Filter by source system (jotpsych, collabmd, etc.) */
  sourceSystem?: string | null;
  /** Filter by claim type (original, corrected, void) */
  claimType?: string | null;
  /** Smart queue filter (needs_attention, ready_to_submit, blocked, submitted, denied, paid, imported). Overrides status if both provided. */
  queue?: string | null;
  /** Include claims that have been superseded by a correction or void. Default hides superseded claims. */
  includeSuperseded?: boolean;
  /** Field to sort by (created_at, service_date_from, total_charge_cents) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2ProviderBillingClaimsByClaimIdApiResponse =
  /** status 200 OK */ OrgClaimDetailResponse;
export type GetV2ProviderBillingClaimsByClaimIdApiArg = {
  claimId: string;
};
export type PostV2ProviderBillingCptChargesLookupApiResponse =
  /** status 200 OK */ CptChargesLookupResponse;
export type PostV2ProviderBillingCptChargesLookupApiArg = {
  cptChargesLookupRequest: CptChargesLookupRequest;
};
export type GetV2ProviderBillingCptChargesByCptCodeApiResponse =
  /** status 200 OK */ CptChargeResponse;
export type GetV2ProviderBillingCptChargesByCptCodeApiArg = {
  cptCode: string;
};
export type GetV2ProviderBillingEncountersApiResponse =
  /** status 200 OK */ OrgBillingEncounterListResponse;
export type GetV2ProviderBillingEncountersApiArg = {
  /** Filter by patient ID */
  patientId?: string | null;
  /** Comma-separated provider IDs to filter by */
  providerIds?: string | null;
  /** Filter by encounter status (e.g. completed) */
  status?: string | null;
  /** Filter by billable status */
  billable?: boolean | null;
  /** Filter by whether encounter has an associated claim */
  hasClaim?: boolean | null;
  /** Comma-separated ready-to-bill statuses to filter by (green, yellow, red) */
  readyToBill?: string | null;
  /** Filter by primary payer UUID */
  payerUuid?: string | null;
  /** Filter encounters from this date (ISO 8601) */
  dateFrom?: string | null;
  /** Filter encounters up to this date (ISO 8601) */
  dateTo?: string | null;
  /** Field to sort by (scheduled_for, created_at) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2ProviderBillingEncountersUnifiedWorklistApiResponse =
  /** status 200 OK */ UnifiedEncounterWorklistResponse;
export type GetV2ProviderBillingEncountersUnifiedWorklistApiArg = {
  /** Filter by list work state */
  workState?: ("all" | "action" | "waiting" | "clear") | null;
  /** Filter by active 5S stage */
  stage?:
    | ("all" | "schedule" | "support" | "sign" | "submit" | "settle")
    | null;
  /** Filter by patient ID */
  patientId?: string | null;
  /** Comma-separated provider IDs to filter by */
  providerIds?: string | null;
  /** Filter by primary payer UUID */
  payerUuid?: string | null;
  /** Filter service dates from ISO date */
  dateFrom?: string | null;
  /** Filter service dates through ISO date */
  dateTo?: string | null;
  /** Filter by work owner */
  owner?:
    | ("front_desk" | "clinician" | "biller" | "payer" | "patient" | "none")
    | null;
  /** Filter by severity */
  severity?: ("info" | "warning" | "error" | "success") | null;
  /** Filter by claim existence */
  hasClaim?: boolean | null;
  /** Filter by resolved bill-with-JotPsych flag */
  billWithJotpsych?: boolean | null;
  /** Only return stale action/waiting items */
  staleOnly?: boolean;
  /** Sort field */
  sortBy?: "dos" | "age" | "amount" | "activity";
  /** Sort direction */
  sortOrder?: "asc" | "desc";
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2ProviderBillingEncountersByEncounterIdApiResponse =
  /** status 200 OK */ OrgBillingEncounterDetailResponse;
export type GetV2ProviderBillingEncountersByEncounterIdApiArg = {
  encounterId: string;
};
export type GetV2ProviderBillingEncountersByEncounterIdClaimWorkspaceApiResponse =
  /** status 200 OK */ UnifiedEncounterClaimWorkspaceResponse;
export type GetV2ProviderBillingEncountersByEncounterIdClaimWorkspaceApiArg = {
  encounterId: string;
  /** Claim ID to select as the active workspace claim. */
  claimId?: string | null;
};
export type PostV2ProviderBillingEncountersByEncounterIdClaimWorkspaceRefreshApiResponse =
  /** status 200 OK */ UnifiedEncounterClaimWorkspaceResponse;
export type PostV2ProviderBillingEncountersByEncounterIdClaimWorkspaceRefreshApiArg =
  {
    encounterId: string;
    unifiedEncounterClaimWorkspaceRefreshRequest: UnifiedEncounterClaimWorkspaceRefreshRequest;
  };
export type GetV2ProviderBillingEncountersByEncounterIdFlowApiResponse =
  /** status 200 OK */ UnifiedEncounterBillingFlowResponse;
export type GetV2ProviderBillingEncountersByEncounterIdFlowApiArg = {
  encounterId: string;
};
export type GetV2ProviderBillingEncountersByEncounterIdOverviewApiResponse =
  /** status 200 OK */ UnifiedEncounterOverviewResponse;
export type GetV2ProviderBillingEncountersByEncounterIdOverviewApiArg = {
  encounterId: string;
};
export type GetV2ProviderBillingEncountersByEncounterIdPaymentsApiResponse =
  /** status 200 OK */ UnifiedEncounterPaymentsWorkspaceResponse;
export type GetV2ProviderBillingEncountersByEncounterIdPaymentsApiArg = {
  encounterId: string;
};
export type GetV2ProviderBillingEncountersByEncounterIdReadinessApiResponse =
  /** status 200 OK */ EncounterReadinessResponse;
export type GetV2ProviderBillingEncountersByEncounterIdReadinessApiArg = {
  encounterId: string;
};
export type GetV2ProviderBillingEncountersByEncounterIdUnifiedApiResponse =
  /** status 200 OK */ UnifiedEncounterBillingResponse;
export type GetV2ProviderBillingEncountersByEncounterIdUnifiedApiArg = {
  encounterId: string;
};
export type GetV2ProviderBillingFeeSchedulesBaselineApiResponse =
  /** status 200 OK */ BaselineRatesGetResponse;
export type GetV2ProviderBillingFeeSchedulesBaselineApiArg = void;
export type PutV2ProviderBillingFeeSchedulesBaselineApiResponse =
  /** status 200 OK */ BaselineRatesUpsertResponse;
export type PutV2ProviderBillingFeeSchedulesBaselineApiArg = {
  baselineRatesUpsertRequest: BaselineRatesUpsertRequest;
};
export type DeleteV2ProviderBillingFeeSchedulesBaselineByCodeIdApiResponse =
  /** status 200 OK */ BaselineRateDeleteResponse;
export type DeleteV2ProviderBillingFeeSchedulesBaselineByCodeIdApiArg = {
  codeId: string;
};
export type PostV2ProviderBillingFeeSchedulesFromExtractionApiResponse =
  /** status 200 OK */ FeeScheduleImportResponse;
export type PostV2ProviderBillingFeeSchedulesFromExtractionApiArg = {
  feeScheduleImportRequest: FeeScheduleImportRequest;
};
export type GetV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRatesApiResponse =
  /** status 200 OK */ PayerExpectedRatesGetResponse;
export type GetV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRatesApiArg =
  {
    payerId: string;
  };
export type PutV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRatesApiResponse =
  /** status 200 OK */ PayerExpectedRatesUpsertResponse;
export type PutV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRatesApiArg =
  {
    payerId: string;
    payerExpectedRatesUpsertRequest: PayerExpectedRatesUpsertRequest;
  };
export type DeleteV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRatesAndCodeIdApiResponse =
  /** status 200 OK */ PayerExpectedRateDeleteResponse;
export type DeleteV2ProviderBillingFeeSchedulesPayersByPayerIdExpectedRatesAndCodeIdApiArg =
  {
    payerId: string;
    codeId: string;
  };
export type GetV2ProviderBillingInvoicesApiResponse =
  /** status 200 OK */ OrgInvoiceListResponse;
export type GetV2ProviderBillingInvoicesApiArg = {
  /** Number of invoices to return */
  limit?: number;
  /** Offset for pagination */
  offset?: number;
  /** Filter by invoice status (draft, open, paid, uncollectible, void) */
  status?: string | null;
  /** Filter by patient ID */
  patientId?: string | null;
};
export type GetV2ProviderBillingPatientsByPatientIdBalanceApiResponse =
  /** status 200 OK */ PatientBalanceResponse;
export type GetV2ProviderBillingPatientsByPatientIdBalanceApiArg = {
  patientId: string;
  /** Filter entries to a single encounter */
  encounterId?: string | null;
  /** Filter by party type: payer or patient */
  partyType?: string | null;
  /** Filter by entry type: charge, payment, adjustment, etc. */
  entryType?: string | null;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type PostV2ProviderBillingPatientsByPatientIdPaymentsApiResponse =
  /** status 201 Created */ RecordPaymentResponse;
export type PostV2ProviderBillingPatientsByPatientIdPaymentsApiArg = {
  patientId: string;
  recordPaymentRequest: RecordPaymentRequest;
};
export type PostV2ProviderBillingPatientsByPatientIdWriteOffsApiResponse =
  /** status 201 Created */ WriteOffResponse;
export type PostV2ProviderBillingPatientsByPatientIdWriteOffsApiArg = {
  patientId: string;
  writeOffRequest: WriteOffRequest;
};
export type GetV2ProviderBillingPayerDocsApiResponse =
  /** status 200 OK */ PayerDocListResponse;
export type GetV2ProviderBillingPayerDocsApiArg = void;
export type GetV2ProviderBillingPayerDocsByPayerKeyApiResponse =
  /** status 200 OK */ PayerDocResponse2;
export type GetV2ProviderBillingPayerDocsByPayerKeyApiArg = {
  payerKey: string;
};
export type PutV2ProviderBillingPayerDocsByPayerKeyApiResponse =
  /** status 200 OK */ PayerDocResponse2;
export type PutV2ProviderBillingPayerDocsByPayerKeyApiArg = {
  payerKey: string;
  payerDocUpsertRequest: PayerDocUpsertRequest;
};
export type GetV2ProviderBillingRemittancesApiResponse =
  /** status 200 OK */ RemittanceListItemResponse;
export type GetV2ProviderBillingRemittancesApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Number of items per page (max 100) */
  perPage?: number;
  /** Filter: earliest payment_date (YYYY-MM-DD) */
  dateFrom?: string | null;
  /** Filter: latest payment_date (YYYY-MM-DD) */
  dateTo?: string | null;
  /** Filter: payer name (case-insensitive partial match) */
  payerName?: string | null;
  /** Filter: payment method code (CHK or ACH) */
  paymentMethod?: string | null;
  /** Filter: source system (e.g. stedi, collabmd) */
  sourceSystem?: string | null;
  /** Filter: minimum total_payment_amount_cents */
  amountMin?: number | null;
  /** Filter: maximum total_payment_amount_cents */
  amountMax?: number | null;
  /** Smart queue filter: all, has_denials, reversals, clean, imported */
  queue?: string | null;
  /** Column to sort by (payment_date, total_payment_amount_cents, created_at, payer_name) */
  sortBy?: string;
  /** Sort direction: asc or desc */
  sortOrder?: string;
};
export type GetV2ProviderBillingRemittancesClaimsByClaimIdSummaryApiResponse =
  /** status 200 OK */ ClaimRemittanceSummaryResponse;
export type GetV2ProviderBillingRemittancesClaimsByClaimIdSummaryApiArg = {
  claimId: string;
};
export type GetV2ProviderBillingRemittancesQueueCountsApiResponse =
  /** status 200 OK */ RemittanceQueueCounts;
export type GetV2ProviderBillingRemittancesQueueCountsApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Number of items per page (max 100) */
  perPage?: number;
  /** Filter: earliest payment_date (YYYY-MM-DD) */
  dateFrom?: string | null;
  /** Filter: latest payment_date (YYYY-MM-DD) */
  dateTo?: string | null;
  /** Filter: payer name (case-insensitive partial match) */
  payerName?: string | null;
  /** Filter: payment method code (CHK or ACH) */
  paymentMethod?: string | null;
  /** Filter: source system (e.g. stedi, collabmd) */
  sourceSystem?: string | null;
  /** Filter: minimum total_payment_amount_cents */
  amountMin?: number | null;
  /** Filter: maximum total_payment_amount_cents */
  amountMax?: number | null;
  /** Smart queue filter: all, has_denials, reversals, clean, imported */
  queue?: string | null;
  /** Column to sort by (payment_date, total_payment_amount_cents, created_at, payer_name) */
  sortBy?: string;
  /** Sort direction: asc or desc */
  sortOrder?: string;
};
export type GetV2ProviderBillingRemittancesByRemittanceIdApiResponse =
  /** status 200 OK */ RemittanceDetailResponse;
export type GetV2ProviderBillingRemittancesByRemittanceIdApiArg = {
  remittanceId: string;
};
export type GetV2ProviderBillingStatementsHistoryApiResponse =
  /** status 200 OK */ StatementHistoryListResponse;
export type GetV2ProviderBillingStatementsHistoryApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by trigger type (ERA_RECEIPT, MANUAL, etc.) */
  triggerType?: string | null;
  /** Filter: YYYY-MM-DD start date */
  dateFrom?: string | null;
  /** Filter: YYYY-MM-DD end date */
  dateTo?: string | null;
};
export type GetV2ProviderBillingStatementsQueueApiResponse =
  /** status 200 OK */ StatementQueueListResponse;
export type GetV2ProviderBillingStatementsQueueApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
};
export type PutV2ProviderEncountersByEncounterIdWorkingBillingClaimApiResponse =
  /** status 200 OK */ EncounterResponse;
export type PutV2ProviderEncountersByEncounterIdWorkingBillingClaimApiArg = {
  encounterId: string;
  workingBillingClaimPutRequest: WorkingBillingClaimPutRequest2;
};
export type GetV2ProviderEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentListResponse;
export type GetV2ProviderEnrollmentsApiArg = void;
export type PostV2ProviderEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2ProviderEnrollmentsApiArg = {
  initiateEnrollmentRequest: InitiateEnrollmentRequest;
};
export type PostV2ProviderEnrollmentsSyncAllApiResponse =
  /** status 200 OK */ SyncAllResponse;
export type PostV2ProviderEnrollmentsSyncAllApiArg = void;
export type GetV2ProviderEnrollmentsByEnrollmentIdApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type GetV2ProviderEnrollmentsByEnrollmentIdApiArg = {
  enrollmentId: string;
};
export type PostV2ProviderEnrollmentsByEnrollmentIdDocumentsApiResponse =
  /** status 200 OK */ UploadDocumentResponse;
export type PostV2ProviderEnrollmentsByEnrollmentIdDocumentsApiArg = {
  enrollmentId: string;
  uploadDocumentRequest: UploadDocumentRequest;
};
export type PostV2ProviderEnrollmentsByEnrollmentIdSyncApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2ProviderEnrollmentsByEnrollmentIdSyncApiArg = {
  enrollmentId: string;
};
export type PostV2ProviderEnrollmentsByEnrollmentIdTasksAndTaskIdApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2ProviderEnrollmentsByEnrollmentIdTasksAndTaskIdApiArg = {
  enrollmentId: string;
  taskId: string;
  completeTaskRequest: CompleteTaskRequest;
};
export type GetV2ProviderServiceFacilitiesApiResponse =
  /** status 200 OK */ ServiceFacilityListResponse;
export type GetV2ProviderServiceFacilitiesApiArg = void;
export type PostV2ProviderServiceFacilitiesApiResponse =
  /** status 200 OK */ ServiceFacilityResponse2;
export type PostV2ProviderServiceFacilitiesApiArg = {
  createServiceFacilityRequest: CreateServiceFacilityRequest;
};
export type DeleteV2ProviderServiceFacilitiesByServiceFacilityIdApiResponse =
  /** status 200 OK */ ServiceFacilityDeleteResponse;
export type DeleteV2ProviderServiceFacilitiesByServiceFacilityIdApiArg = {
  serviceFacilityId: string;
};
export type GetV2ProviderServiceFacilitiesByServiceFacilityIdApiResponse =
  /** status 200 OK */ ServiceFacilityResponse2;
export type GetV2ProviderServiceFacilitiesByServiceFacilityIdApiArg = {
  serviceFacilityId: string;
};
export type PutV2ProviderServiceFacilitiesByServiceFacilityIdApiResponse =
  /** status 200 OK */ ServiceFacilityResponse2;
export type PutV2ProviderServiceFacilitiesByServiceFacilityIdApiArg = {
  serviceFacilityId: string;
  updateServiceFacilityRequest: UpdateServiceFacilityRequest;
};
export type PostV2ProviderServiceFacilitiesByServiceFacilityIdSetDefaultApiResponse =
  /** status 200 OK */ ServiceFacilityResponse2;
export type PostV2ProviderServiceFacilitiesByServiceFacilityIdSetDefaultApiArg =
  {
    serviceFacilityId: string;
  };
export type PostV2ProviderStediConnectApiResponse =
  /** status 200 OK */ ConnectStediResponse;
export type PostV2ProviderStediConnectApiArg = {
  connectStediRequest: ConnectStediRequest;
};
export type DeleteV2ProviderStediDisconnectApiResponse =
  /** status 200 OK */ DisconnectStediResponse;
export type DeleteV2ProviderStediDisconnectApiArg = void;
export type GetV2ProviderStediStatusApiResponse =
  /** status 200 OK */ StediConnectionStatusResponse;
export type GetV2ProviderStediStatusApiArg = void;
export type PostV2ProviderStediVerifyApiResponse =
  /** status 200 OK */ VerifyStediResponse;
export type PostV2ProviderStediVerifyApiArg = void;
export type MorningWorklistClaimCounts = {
  denied?: number;
  draft?: number;
  in_flight?: number;
  ready?: number;
  rejected?: number;
};
export type MorningWorklistWorkItem = {
  count?: number;
  kind:
    | "scrub_draft_claims"
    | "submit_ready_claims"
    | "denied_claims"
    | "rejected_claims"
    | "in_flight_claims_over_14_days";
  label: string;
  oldest_age_days?: number | null;
  owner?: "rcm_ops" | "payer";
  urgency?: "critical" | "high" | "medium" | "watch";
};
export type MorningWorklistOrganization = {
  claims: MorningWorklistClaimCounts;
  organization_id: string;
  organization_name?: string | null;
  urgency?: "critical" | "high" | "medium" | "watch";
  work_items?: MorningWorklistWorkItem[];
};
export type MorningWorklistSummary = {
  claims: MorningWorklistClaimCounts;
  organization_count?: number;
};
export type MorningWorklistResponse = {
  has_more?: boolean;
  organizations?: MorningWorklistOrganization[];
  page?: number;
  per_page?: number;
  summary: MorningWorklistSummary;
  total?: number;
  total_pages?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type HiddenMorningWorklistOrganizationResponse = {
  hidden_at?: string | null;
  hidden_by?: string | null;
  organization_id: string;
  organization_name?: string | null;
  reason?: string | null;
};
export type HiddenMorningWorklistOrganizationsResponse = {
  organizations?: HiddenMorningWorklistOrganizationResponse[];
};
export type HiddenMorningWorklistOrganizationResponse2 = {
  hidden_at?: string | null;
  hidden_by?: string | null;
  organization_id: string;
  organization_name?: string | null;
  reason?: string | null;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type HideMorningWorklistOrganizationRequest = {
  organization_id: string;
  reason?: string | null;
};
export type UnhideMorningWorklistOrganizationResponse = {
  organization_id: string;
};
export type OrganizationBillingSummary = {
  active_billing_providers?: number;
  claims_created_last_30d?: number;
  claims_denied?: number;
  claims_draft?: number;
  claims_in_flight?: number;
  claims_needs_attention?: number;
  claims_paid?: number;
  claims_ready?: number;
  claims_rejected?: number;
  claims_submitted_last_30d?: number;
  collection_rate_pct?: number | null;
  denial_count?: number;
  denial_rate_pct?: number | null;
  last_claim_created_at?: string | null;
  last_remittance_at?: string | null;
  last_submission_at?: string | null;
  morning_priority?: number;
  morning_work_item_count?: number;
  oldest_denied_age_days?: number | null;
  oldest_draft_age_days?: number | null;
  oldest_in_flight_age_days?: number | null;
  oldest_open_claim_age_days?: number | null;
  oldest_ready_age_days?: number | null;
  oldest_rejected_age_days?: number | null;
  organization_id: string;
  organization_name?: string | null;
  rejection_count?: number;
  remittances_received?: number;
  reversal_count?: number;
  total_balance_cents?: number;
  total_charge_cents?: number;
  total_claims?: number;
  total_paid_cents?: number;
  total_remittance_payment_cents?: number;
  unmatched_remittance_claims?: number;
};
export type OrganizationBillingListResponse = {
  has_more?: boolean;
  organizations?: OrganizationBillingSummary[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type OrganizationBillingDetailResponse = {
  active_billing_providers?: number;
  claims_created_last_30d?: number;
  claims_denied?: number;
  claims_draft?: number;
  claims_in_flight?: number;
  claims_needs_attention?: number;
  claims_paid?: number;
  claims_ready?: number;
  claims_rejected?: number;
  claims_submitted_last_30d?: number;
  collection_rate_pct?: number | null;
  denial_count?: number;
  denial_rate_pct?: number | null;
  encounters_ready_to_bill?: number | null;
  last_claim_created_at?: string | null;
  last_remittance_at?: string | null;
  last_submission_at?: string | null;
  morning_priority?: number;
  morning_work_item_count?: number;
  oldest_denied_age_days?: number | null;
  oldest_draft_age_days?: number | null;
  oldest_in_flight_age_days?: number | null;
  oldest_open_claim_age_days?: number | null;
  oldest_ready_age_days?: number | null;
  oldest_rejected_age_days?: number | null;
  organization_id: string;
  organization_name?: string | null;
  rejection_count?: number;
  remittances_received?: number;
  reversal_count?: number;
  total_balance_cents?: number;
  total_charge_cents?: number;
  total_claims?: number;
  total_paid_cents?: number;
  total_remittance_payment_cents?: number;
  unmatched_remittance_claims?: number;
};
export type JuneRcmScoreboardOrgRow = {
  claims_draft_count?: number;
  claims_in_flight_count?: number;
  claims_missing_payer_response_count?: number;
  claims_needing_attention_count?: number;
  claims_paid_or_adjudicated_count?: number;
  claims_ready_count?: number;
  claims_submitted_count?: number;
  claims_with_payer_response_count?: number;
  clean_outcome_count?: number;
  collected_take_cents?: number;
  era_claim_charge_cents?: number;
  era_claim_row_count?: number;
  era_count?: number;
  era_denial_or_reversal_count?: number;
  insurance_payment_from_era_cents?: number;
  insurance_payment_ledger_entry_count?: number;
  insurance_payment_posted_to_ledger_cents?: number;
  insurance_take_cents?: number;
  invoiced_take_cents?: number;
  jotpsych_take_cents?: number;
  last_invoice_paid_at?: string | null;
  last_patient_payment_at?: string | null;
  last_payer_response_date?: string | null;
  oldest_in_flight_age_days?: number | null;
  oldest_ready_age_days?: number | null;
  organization_id: string;
  organization_name?: string | null;
  paid_patient_invoice_amount_cents?: number;
  paid_patient_invoice_count?: number;
  patient_payment_allocated_cents?: number;
  patient_payment_count?: number;
  patient_responsibility_from_era_cents?: number;
  period_end?: string | null;
  period_start?: string | null;
  provider_invoice_amount_cents?: number;
  submitted_claim_amount_cents?: number;
  take_rate_bps?: number;
  target_claims_paid_cents?: number;
};
export type JuneRcmScoreboardSummary = {
  claims_draft_count?: number;
  claims_in_flight_count?: number;
  claims_missing_payer_response_count?: number;
  claims_needing_attention_count?: number;
  claims_paid_or_adjudicated_count?: number;
  claims_paid_progress_pct?: number | null;
  claims_ready_count?: number;
  claims_submitted_count?: number;
  claims_with_payer_response_count?: number;
  clean_outcome_count?: number;
  collected_take_cents?: number;
  era_claim_charge_cents?: number;
  era_claim_row_count?: number;
  era_count?: number;
  era_denial_or_reversal_count?: number;
  insurance_payment_from_era_cents?: number;
  insurance_payment_ledger_entry_count?: number;
  insurance_payment_posted_to_ledger_cents?: number;
  insurance_take_cents?: number;
  invoiced_take_cents?: number;
  jotpsych_take_cents?: number;
  last_invoice_paid_at?: string | null;
  last_patient_payment_at?: string | null;
  last_payer_response_date?: string | null;
  oldest_in_flight_age_days?: number | null;
  oldest_ready_age_days?: number | null;
  organization_count?: number;
  paid_patient_invoice_amount_cents?: number;
  paid_patient_invoice_count?: number;
  patient_payment_allocated_cents?: number;
  patient_payment_count?: number;
  patient_responsibility_from_era_cents?: number;
  period?: string;
  period_end?: string | null;
  period_label?: string;
  period_start?: string | null;
  provider_invoice_amount_cents?: number;
  submitted_claim_amount_cents?: number;
  target_claims_paid_cents?: number;
};
export type JuneRcmScoreboardResponse = {
  has_more?: boolean;
  organizations?: JuneRcmScoreboardOrgRow[];
  page?: number;
  per_page?: number;
  summary: JuneRcmScoreboardSummary;
  total?: number;
  total_pages?: number;
};
export type SalesScoreboardResponse = {
  /** Active subscription count 30 days ago (churn denominator) */
  churn_base_logos?: number;
  /** Subscriptions canceled in the last 30 days */
  churned_logos?: number;
  /** UTC ISO timestamp when the snapshot was computed; None while the cache is warming */
  computed_at?: string | null;
  /** Trailing 30-day gross logo churn = churned_last_30d / active_30d_ago × 100 */
  gross_churn_pct?: number | null;
  /** Clinicians at Pipeline stage = Go-live in JotBill Tracker */
  jotbill_golive_count?: number;
  /** June target for JotBill Go-live clinicians */
  jotbill_golive_goal?: number;
  /** Go-live count / goal × 100 */
  jotbill_golive_pct?: number | null;
  /** Active subscription count at the MRR period start */
  logos_at_period_start?: number;
  /** Current MRR in cents */
  mrr_current_cents?: number;
  /** MRR at the start of the period in cents */
  mrr_period_start_cents?: number;
  /** Net MRR growth (current − start) in cents */
  net_mrr_growth_cents?: number;
  /** Whether the Notion JotBill Tracker DB was reachable */
  notion_accessible?: boolean;
  /** Error message if Notion DB was not accessible */
  notion_error?: string | null;
  /** Inclusive end date in YYYY-MM-DD format */
  period_end: string;
  /** Inclusive start date in YYYY-MM-DD format */
  period_start: string;
  /** Whether Stripe subscription data was fetched completely */
  stripe_accessible?: boolean;
  /** Error message if Stripe data could not be fetched */
  stripe_error?: string | null;
};
export type RuleSeedResponse = {
  errors?: string[];
  message: string;
  rules_created: number;
  rules_skipped: number;
  success: boolean;
};
export type SubmissionBlockerResponse = {
  /** Recommended action to resolve */
  action: string;
  /** Machine-readable blocker code */
  code: string;
  /** Additional context */
  details?: {
    [key: string]: any;
  } | null;
  /** Readiness level (1=org, 2=entity, 3=payer, 4=claim) */
  level: number;
  /** Human-readable description */
  message: string;
};
export type ClaimSubmissionReadinessResponse = {
  blockers: SubmissionBlockerResponse[];
  can_generate: boolean;
  can_submit: boolean;
  claim_id: string;
  enrollment_status: string | null;
  evaluated_at: string;
  payer_status: string | null;
  status: string;
};
export type BillingAddressResponse = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type SyncStatus =
  | "NOT_SYNCED"
  | "SYNCED"
  | "SYNC_FAILED"
  | "NEEDS_RESYNC";
export type BillingEntityResponse = {
  billing_address: BillingAddressResponse;
  billing_entity_id: string;
  billing_npi: string;
  contact_email: string | null;
  contact_name: string | null;
  contact_phone: string | null;
  created_at: string;
  doing_business_as: string | null;
  is_default: boolean;
  legal_name: string;
  organization_id: string;
  stedi_provider_id: string | null;
  stedi_synced: boolean;
  stedi_synced_at: string | null;
  sync_status: SyncStatus;
  tax_id_masked: string;
  tax_id_type: string;
  taxonomy_code: string | null;
  updated_at: string;
};
export type BillingEntityListResponse = {
  billing_entities: BillingEntityResponse[];
};
export type BillingAddressResponse2 = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type SyncStatus2 =
  | "NOT_SYNCED"
  | "SYNCED"
  | "SYNC_FAILED"
  | "NEEDS_RESYNC";
export type BillingEntityResponse2 = {
  billing_address: BillingAddressResponse2;
  billing_entity_id: string;
  billing_npi: string;
  contact_email: string | null;
  contact_name: string | null;
  contact_phone: string | null;
  created_at: string;
  doing_business_as: string | null;
  is_default: boolean;
  legal_name: string;
  organization_id: string;
  stedi_provider_id: string | null;
  stedi_synced: boolean;
  stedi_synced_at: string | null;
  sync_status: SyncStatus2;
  tax_id_masked: string;
  tax_id_type: string;
  taxonomy_code: string | null;
  updated_at: string;
};
export type BillingAddressSchema = {
  city: string;
  line1: string;
  line2?: string | null;
  state: string;
  zip: string;
};
export type CreateBillingEntityRequest = {
  billing_address: BillingAddressSchema;
  billing_npi: string;
  contact_email?: string | null;
  contact_name?: string | null;
  contact_phone?: string | null;
  doing_business_as?: string | null;
  is_default?: boolean;
  legal_name: string;
  tax_id: string;
  tax_id_type: string;
  taxonomy_code?: string | null;
};
export type BillingEntityDeleteResponse = {
  /** Whether deletion was successful */
  deleted: boolean;
};
export type BillingAddressUpdateSchema = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type UpdateBillingEntityRequest = {
  billing_address?: BillingAddressUpdateSchema | null;
  billing_npi?: string | null;
  contact_email?: string | null;
  contact_name?: string | null;
  contact_phone?: string | null;
  doing_business_as?: string | null;
  is_default?: boolean | null;
  legal_name?: string | null;
  tax_id?: string | null;
  tax_id_type?: ("EIN" | "SSN") | null;
  taxonomy_code?: string | null;
};
export type PayerReadinessResponse = {
  action_required: string | null;
  blockers: string[];
  can_submit: boolean;
  enrollment_status: string | null;
  payer_name: string;
  payer_support: string;
  payer_uuid: string;
};
export type SyncToStediResponse = {
  error?: string | null;
  error_code?: string | null;
  stedi_provider_id?: string | null;
  success: boolean;
  synced_at?: string | null;
};
export type BillingEntityStatusResponse = {
  billing_entity_id: string;
  billing_npi: string | null;
  is_complete: boolean;
  is_default: boolean;
  is_synced: boolean;
  issues: string[];
  legal_name: string;
};
export type PayerEnrollmentStatusResponse = {
  action_required: string | null;
  can_submit: boolean;
  enrollment_status: string | null;
  payer_name: string;
  payer_support: string;
  payer_uuid: string;
  transaction_type: string;
};
export type OrgBillingReadinessResponse = {
  billing_entities: BillingEntityStatusResponse[];
  enrollment_summary: {
    [key: string]: PayerEnrollmentStatusResponse[];
  };
  evaluated_at: string;
  organization_id: string;
  overall_status: string;
  stedi_config_issues: string[];
  stedi_connected: boolean;
};
export type PayerDocResponse = {
  created_at?: string | null;
  organization_id: string;
  payer_doc_id: string;
  payer_key: string;
  payer_name?: string | null;
  payer_uuid?: string | null;
  payload?: {
    [key: string]: any;
  };
  updated_at?: string | null;
};
export type PayerDocListResponse = {
  items?: PayerDocResponse[];
  total: number;
};
export type PayerDocResponse2 = {
  created_at?: string | null;
  organization_id: string;
  payer_doc_id: string;
  payer_key: string;
  payer_name?: string | null;
  payer_uuid?: string | null;
  payload?: {
    [key: string]: any;
  };
  updated_at?: string | null;
};
export type PayerDocUpsertRequest = {
  /** Optional display name for this payer doc */
  payer_name?: string | null;
  /** Optional canonical payer reference (payers.id) */
  payer_uuid?: string | null;
  /** Raw payer JSON payload (jotbill-payer-contract-v2) */
  payload?: {
    [key: string]: any;
  };
};
export type EnrollmentResponse = {
  billing_entity_id: string;
  created_at: string;
  last_synced_at: string | null;
  live_at: string | null;
  organization_id: string;
  /** Payer logo URL */
  payer_avatar_url?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  payer_uuid: string | null;
  /** Payer website URL */
  payer_website_url?: string | null;
  rejection_reason: string | null;
  requested_at: string | null;
  status: string;
  status_message: string | null;
  stedi_enrollment_id: string | null;
  stedi_payer_id: string;
  stedi_transaction_enrollment_id: string;
  submitted_at: string | null;
  /** Outstanding Stedi tasks for this enrollment */
  tasks?: {
    [key: string]: any;
  }[];
  transaction_type: string;
  updated_at: string;
};
export type EnrollmentListResponse = {
  enrollments: EnrollmentResponse[];
};
export type EnrollmentResponse2 = {
  billing_entity_id: string;
  created_at: string;
  last_synced_at: string | null;
  live_at: string | null;
  organization_id: string;
  /** Payer logo URL */
  payer_avatar_url?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  payer_uuid: string | null;
  /** Payer website URL */
  payer_website_url?: string | null;
  rejection_reason: string | null;
  requested_at: string | null;
  status: string;
  status_message: string | null;
  stedi_enrollment_id: string | null;
  stedi_payer_id: string;
  stedi_transaction_enrollment_id: string;
  submitted_at: string | null;
  /** Outstanding Stedi tasks for this enrollment */
  tasks?: {
    [key: string]: any;
  }[];
  transaction_type: string;
  updated_at: string;
};
export type InitiateEnrollmentRequest = {
  /** Billing entity to enroll */
  billing_entity_id: string;
  /** Internal payer UUID (from local database) */
  payer_uuid?: string | null;
  /** Stedi payer ID (from payer search results) */
  stedi_id?: string | null;
  /** Transaction type: 837P (claims) or 835 (ERA) */
  transaction_type?: string;
};
export type EnrollmentResponse3 = {
  billing_entity_id: string;
  created_at: string;
  last_synced_at: string | null;
  live_at: string | null;
  organization_id: string;
  /** Payer logo URL */
  payer_avatar_url?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  payer_uuid: string | null;
  /** Payer website URL */
  payer_website_url?: string | null;
  rejection_reason: string | null;
  requested_at: string | null;
  status: string;
  status_message: string | null;
  stedi_enrollment_id: string | null;
  stedi_payer_id: string;
  stedi_transaction_enrollment_id: string;
  submitted_at: string | null;
  /** Outstanding Stedi tasks for this enrollment */
  tasks?: {
    [key: string]: any;
  }[];
  transaction_type: string;
  updated_at: string;
};
export type SyncAllResponse = {
  enrollments: EnrollmentResponse3[];
  synced_count: number;
};
export type JotBillFeeInvoiceSchema = {
  created_at?: string | null;
  created_by?: string | null;
  credit_cents: number;
  fee_subtotal_cents: number;
  finalized_at?: string | null;
  jotbill_fee_invoice_id: string;
  organization_id: string;
  paid_at?: string | null;
  period_end: string;
  period_start: string;
  run_source: string;
  status: string;
  stripe_invoice_id?: string | null;
  take_rate_bps: number;
  total_cents: number;
};
export type JotBillFeeInvoiceListResponse = {
  invoices?: JotBillFeeInvoiceSchema[];
};
export type JotBillFeeInvoiceSchema2 = {
  created_at?: string | null;
  created_by?: string | null;
  credit_cents: number;
  fee_subtotal_cents: number;
  finalized_at?: string | null;
  jotbill_fee_invoice_id: string;
  organization_id: string;
  paid_at?: string | null;
  period_end: string;
  period_start: string;
  run_source: string;
  status: string;
  stripe_invoice_id?: string | null;
  take_rate_bps: number;
  total_cents: number;
};
export type JotBillFeeLineSchema = {
  base_payment_cents: number;
  claim_id?: string | null;
  /** Positive for fees, negative for reversal credits */
  fee_cents: number;
  /** 'fee' or 'reversal_credit' */
  line_type: string;
  remittance_claim_id: string;
  take_rate_bps: number;
};
export type JotBillFeeInvoiceDetailResponse = {
  invoice: JotBillFeeInvoiceSchema2;
  lines?: JotBillFeeLineSchema[];
};
export type JotBillFeeLineSchema2 = {
  base_payment_cents: number;
  claim_id?: string | null;
  /** Positive for fees, negative for reversal credits */
  fee_cents: number;
  /** 'fee' or 'reversal_credit' */
  line_type: string;
  remittance_claim_id: string;
  take_rate_bps: number;
};
export type JotBillFeeRunResponse = {
  credit_cents: number;
  dry_run: boolean;
  fee_subtotal_cents: number;
  /** Set when commit=true created an invoice */
  invoice_id?: string | null;
  line_count: number;
  lines?: JotBillFeeLineSchema2[];
  organization_id: string;
  period_end: string;
  period_start: string;
  /** 'not_enabled', 'no_candidates', 'below_minimum', or 'negative_total' when no invoice would be created */
  skipped_reason?: string | null;
  take_rate_bps: number;
  total_cents: number;
};
export type RunJotBillFeeBillingRequest = {
  /** False (default) previews; true creates the invoice */
  commit?: boolean;
  /** Billing window end, exclusive (ISO 8601) */
  period_end: string;
  /** Billing window start (ISO 8601, remittance ingestion time) */
  period_start: string;
};
export type JotBillTakeConfigResponse = {
  /** ISO 8601 timestamp; only remittances ingested at/after this timestamp are billable */
  effective_at?: string | null;
  /** Whether JotBill take fee billing is enabled */
  enabled: boolean;
  /** Organization the config belongs to */
  organization_id: string;
  /** Participation rate in basis points (400 = 4%, 600 = 6%, 800 = 8%) */
  take_rate_bps: number;
  /** ISO 8601 timestamp of the last config change */
  updated_at?: string | null;
  /** Admin user ID that made the last config change */
  updated_by?: string | null;
};
export type UpdateJotBillTakeConfigRequest = {
  /** ISO 8601 timestamp; only remittances ingested at/after this timestamp are billable */
  effective_at?: string | null;
  /** Enable or disable JotBill take fee billing */
  enabled?: boolean | null;
  /** Participation rate in basis points (400 = 4%, 600 = 6%, 800 = 8%) */
  take_rate_bps?: number | null;
};
export type RemittanceHeaderResponse = {
  /** 'test' or 'production' */
  application_mode?: string | null;
  /** Check number or EFT trace number */
  check_or_eft_trace_number: string;
  /** Number of claims in this remittance */
  claim_count?: number;
  created_at?: string | null;
  organization_id: string;
  /** Name of the entity that received payment */
  payee_name?: string | null;
  /** NPI of the entity that received payment */
  payee_npi?: string | null;
  /** Payer's identifier code */
  payer_identifier?: string | null;
  /** Name of the paying entity */
  payer_name?: string | null;
  /** Date the payer issued payment (from 835 DTM*405). Use this instead of created_at for display. */
  payment_date?: string | null;
  /** CHK (check) or ACH (electronic) */
  payment_method_code?: string | null;
  remittance_id: string;
  /** Origin of this ERA: 'stedi' (live) or source system slug for imports */
  source_system?: string | null;
  stedi_transaction_id?: string | null;
  /** Total payment in cents across all claims in this 835 */
  total_payment_amount_cents?: number | null;
  transaction_task_id?: string | null;
};
export type RemittanceListResponse = {
  /** List of remittance payment events for the current page */
  items?: RemittanceHeaderResponse[];
  /** Current page number (1-based) */
  page: number;
  /** Number of items per page */
  per_page: number;
  /** Total number of remittances matching filters */
  total: number;
  /** Total number of pages available */
  total_pages: number;
};
export type RemittanceLineResponse = {
  /** CPT/HCPCS code the payer adjudicated */
  adjudicated_procedure_code?: string | null;
  /** Modifier codes on the adjudicated procedure */
  adjudicated_procedure_modifier_codes?: string[] | null;
  claim_line_id?: string | null;
  /** Billed amount for this line in cents */
  line_item_charge_amount_cents?: number | null;
  /** Our submitted line control number */
  line_item_control_number?: string | null;
  /** Paid amount for this line in cents */
  line_item_payment_amount_cents?: number | null;
  original_units_of_service_count?: number | null;
  /** RARC remark codes. Each entry: {remarkCode, remark, codeListQualifierCode} */
  remark_codes?: {
    [key: string]: any;
  }[];
  remittance_line_id: string;
  /** Line-level adjustments. Each entry: {groupCode, reasonCode, reasonDescription, amountCents} */
  service_adjustments?: {
    [key: string]: any;
  }[];
  service_date?: string | null;
  /** Original submitted code (if payer changed it) */
  submitted_procedure_code?: string | null;
};
export type RemittanceClaimResponse = {
  /** Claim-level adjustments. Each entry: {groupCode, reasonCode, reasonDescription, amountCents}. groupCode: CO=contractual, PR=patient responsibility, OA=other, PI=payor initiated, CR=corrections */
  claim_adjustments?: {
    [key: string]: any;
  }[];
  /** 1=original, 7=replacement, 8=void */
  claim_frequency_code?: string | null;
  /** Matched internal claim ID (null if unmatched) */
  claim_id?: string | null;
  /** Amount paid in cents (CLP04) */
  claim_payment_amount_cents?: number | null;
  claim_received_date?: string | null;
  /** CLP02: 1=processed, 4=denied, 22=reversal, etc. */
  claim_status_code: string;
  /** Payer id of the crossover carrier. Null unless forwarded. */
  crossover_carrier_id?: string | null;
  /** Name of the payer the primary forwarded to (835 NM1*TT / Stedi crossoverCarrier). Null unless forwarded. */
  crossover_carrier_name?: string | null;
  /** Encounter ID from the linked claim (null if unmatched) */
  encounter_id?: string | null;
  /** True if payer forwarded to secondary insurance */
  forwarded_to_secondary?: boolean;
  /** Service line adjudication details */
  lines?: RemittanceLineResponse[];
  /** Our PCN used to match this to a claim */
  patient_control_number: string;
  patient_first_name?: string | null;
  /** Internal patient ID from the linked claim (null if unmatched). Use this to fetch patient details when wiring 'Bill Patient' actions. */
  patient_id?: string | null;
  patient_last_name?: string | null;
  patient_member_id?: string | null;
  /** Patient owes in cents (CLP05) */
  patient_responsibility_amount_cents?: number | null;
  /** Payer's internal claim reference (CLP07) */
  payer_claim_control_number?: string | null;
  remittance_claim_id: string;
  remittance_id: string;
  rendering_provider_npi?: string | null;
  statement_period_end?: string | null;
  statement_period_start?: string | null;
  /** Total billed amount in cents (CLP03) */
  total_claim_charge_amount_cents?: number | null;
};
export type ClaimRemittanceSummaryResponse = {
  claim_id: string;
  /** Trace number from the most recent 835 */
  latest_check_or_eft_trace_number?: string | null;
  /** Payer name from the most recent 835 */
  latest_payer_name?: string | null;
  /** Payment method from the most recent 835 */
  latest_payment_method_code?: string | null;
  /** Sum of all claim_payment_amount_cents across all 835s */
  net_payment_cents?: number;
  /** Remittance claim records with nested lines. Multiple entries means multiple 835s processed for this claim. */
  remittance_records?: RemittanceClaimResponse[];
  /** Sum of all adjustment amounts across all 835s */
  total_adjustments_cents?: number;
};
export type RemittanceLineResponse2 = {
  /** CPT/HCPCS code the payer adjudicated */
  adjudicated_procedure_code?: string | null;
  /** Modifier codes on the adjudicated procedure */
  adjudicated_procedure_modifier_codes?: string[] | null;
  claim_line_id?: string | null;
  /** Billed amount for this line in cents */
  line_item_charge_amount_cents?: number | null;
  /** Our submitted line control number */
  line_item_control_number?: string | null;
  /** Paid amount for this line in cents */
  line_item_payment_amount_cents?: number | null;
  original_units_of_service_count?: number | null;
  /** RARC remark codes. Each entry: {remarkCode, remark, codeListQualifierCode} */
  remark_codes?: {
    [key: string]: any;
  }[];
  remittance_line_id: string;
  /** Line-level adjustments. Each entry: {groupCode, reasonCode, reasonDescription, amountCents} */
  service_adjustments?: {
    [key: string]: any;
  }[];
  service_date?: string | null;
  /** Original submitted code (if payer changed it) */
  submitted_procedure_code?: string | null;
};
export type RemittanceClaimResponse2 = {
  /** Claim-level adjustments. Each entry: {groupCode, reasonCode, reasonDescription, amountCents}. groupCode: CO=contractual, PR=patient responsibility, OA=other, PI=payor initiated, CR=corrections */
  claim_adjustments?: {
    [key: string]: any;
  }[];
  /** 1=original, 7=replacement, 8=void */
  claim_frequency_code?: string | null;
  /** Matched internal claim ID (null if unmatched) */
  claim_id?: string | null;
  /** Amount paid in cents (CLP04) */
  claim_payment_amount_cents?: number | null;
  claim_received_date?: string | null;
  /** CLP02: 1=processed, 4=denied, 22=reversal, etc. */
  claim_status_code: string;
  /** Payer id of the crossover carrier. Null unless forwarded. */
  crossover_carrier_id?: string | null;
  /** Name of the payer the primary forwarded to (835 NM1*TT / Stedi crossoverCarrier). Null unless forwarded. */
  crossover_carrier_name?: string | null;
  /** Encounter ID from the linked claim (null if unmatched) */
  encounter_id?: string | null;
  /** True if payer forwarded to secondary insurance */
  forwarded_to_secondary?: boolean;
  /** Service line adjudication details */
  lines?: RemittanceLineResponse2[];
  /** Our PCN used to match this to a claim */
  patient_control_number: string;
  patient_first_name?: string | null;
  /** Internal patient ID from the linked claim (null if unmatched). Use this to fetch patient details when wiring 'Bill Patient' actions. */
  patient_id?: string | null;
  patient_last_name?: string | null;
  patient_member_id?: string | null;
  /** Patient owes in cents (CLP05) */
  patient_responsibility_amount_cents?: number | null;
  /** Payer's internal claim reference (CLP07) */
  payer_claim_control_number?: string | null;
  remittance_claim_id: string;
  remittance_id: string;
  rendering_provider_npi?: string | null;
  statement_period_end?: string | null;
  statement_period_start?: string | null;
  /** Total billed amount in cents (CLP03) */
  total_claim_charge_amount_cents?: number | null;
};
export type RemittanceHeaderResponse2 = {
  /** 'test' or 'production' */
  application_mode?: string | null;
  /** Check number or EFT trace number */
  check_or_eft_trace_number: string;
  /** Number of claims in this remittance */
  claim_count?: number;
  created_at?: string | null;
  organization_id: string;
  /** Name of the entity that received payment */
  payee_name?: string | null;
  /** NPI of the entity that received payment */
  payee_npi?: string | null;
  /** Payer's identifier code */
  payer_identifier?: string | null;
  /** Name of the paying entity */
  payer_name?: string | null;
  /** Date the payer issued payment (from 835 DTM*405). Use this instead of created_at for display. */
  payment_date?: string | null;
  /** CHK (check) or ACH (electronic) */
  payment_method_code?: string | null;
  remittance_id: string;
  /** Origin of this ERA: 'stedi' (live) or source system slug for imports */
  source_system?: string | null;
  stedi_transaction_id?: string | null;
  /** Total payment in cents across all claims in this 835 */
  total_payment_amount_cents?: number | null;
  transaction_task_id?: string | null;
};
export type RemittanceDetailResponse = {
  /** All claims adjudicated in this payment */
  claims?: RemittanceClaimResponse2[];
  remittance: RemittanceHeaderResponse2;
};
export type ConnectStediResponse = {
  /** Whether connection was successful */
  connected: boolean;
  /** When the connection was established */
  connected_at?: string | null;
  /** Status message */
  message?: string;
};
export type ConnectStediRequest = {
  /** Optional label for debugging/display (e.g., clinic name) */
  account_label?: string | null;
  /** Plaintext API key from Stedi app installation */
  api_key: string;
};
export type DisconnectStediResponse = {
  /** Whether disconnection was successful */
  disconnected: boolean;
  /** Status message */
  message?: string;
};
export type StediConnectionStatusResponse = {
  /** Account label for display */
  account_label?: string | null;
  /** Whether the org is connected to Stedi */
  connected: boolean;
  /** When the org first connected */
  connected_at?: string | null;
  /** Whether Stedi integration is enabled */
  enabled: boolean;
  /** When connection was last verified */
  last_verified_at?: string | null;
  /** Account mode: DEDICATED or SHARED */
  mode?: string | null;
  /** Last verification error, if any */
  verification_error?: string | null;
};
export type StediTransactionListResponse = {
  /** List of transaction objects from the Stedi Core API */
  items: {
    [key: string]: any;
  }[];
  /** Cursor token for the next page of results */
  next_page_token?: string | null;
};
export type StediTransactionDetailResponse = {
  /** Parsed JSON content of the transaction output artifact. For 837 claims: full claim payload (payer, subscriber, service lines, etc.). For 277/835: parsed report content. Null if the output artifact could not be fetched. */
  output?: {
    [key: string]: any;
  } | null;
  /** Full transaction metadata from the Stedi Core API */
  transaction: {
    [key: string]: any;
  };
};
export type VerifyStediResponse = {
  /** Error message if validation failed */
  error?: string | null;
  /** Whether the connection is valid */
  valid: boolean;
  /** When the verification was performed */
  verified_at?: string | null;
};
export type PayerSyncResponse = {
  message: string;
  success: boolean;
  task_id?: string | null;
};
export type PayerSyncStatusResponse = {
  last_synced_at?: string | null;
  message: string;
  payer_count: number;
};
export type BillingMigrationSessionResponse = {
  completed_at?: string | null;
  created_at?: string | null;
  error_messages?: {
    [key: string]: any;
  }[];
  import_stats?: {
    [key: string]: any;
  };
  organization_id: string;
  preview_data?: {
    [key: string]: any;
  } | null;
  session_id: string;
  source_system: string;
  status: string;
  updated_at?: string | null;
};
export type BillingMigrationSessionListResponse = {
  sessions: BillingMigrationSessionResponse[];
};
export type BillingMigrationSessionResponse2 = {
  completed_at?: string | null;
  created_at?: string | null;
  error_messages?: {
    [key: string]: any;
  }[];
  import_stats?: {
    [key: string]: any;
  };
  organization_id: string;
  preview_data?: {
    [key: string]: any;
  } | null;
  session_id: string;
  source_system: string;
  status: string;
  updated_at?: string | null;
};
export type BillingMigrationConfirmResponse = {
  import_stats?: {
    [key: string]: any;
  };
  session_id: string;
  status: string;
};
export type BillingMigrationUploadResponse = {
  files_received: number;
  session_id: string;
  status: string;
};
export type CaptureChargesResponse = {
  /** IDs of created charge lines */
  charge_line_ids: string[];
  /** Sum of all charge amounts */
  total_charge_cents: number;
};
export type ChargeItem = {
  /** Billing code (e.g., CPT:99214, HCPCS:H0031) */
  billing_code?: string | null;
  /** Charge amount in cents */
  charge_amount_cents: number;
  /** Service description */
  description?: string | null;
  /** Number of units */
  units?: number;
};
export type CaptureChargesRequest = {
  /** Encounter to associate charges with (optional) */
  encounter_id?: string | null;
  /** At least one charge item */
  items: ChargeItem[];
  /** Patient ID */
  patient_id: string;
};
export type ClaimListItem = {
  /** Amount paid by payer in cents */
  amount_paid_cents?: number | null;
  /** Balance due in cents */
  balance_due_cents?: number | null;
  /** Claim ID */
  claim_id: string;
  /** Claim type: original, corrected, or void */
  claim_type?: string | null;
  /** Whether this claim can be corrected (post-submission + has PCN) */
  correction_eligible?: boolean;
  /** When claim was created */
  created_at: string;
  /** Days elapsed since submission */
  days_since_submission?: number | null;
  /** Encounter ID for linking to encounter detail */
  encounter_id?: string | null;
  /** Number of ERROR severity annotations */
  error_count?: number;
  /** Whether this claim has correction or void children */
  has_children?: boolean;
  /** Whether any ERA has been received for this claim */
  has_remittance?: boolean;
  /** Number of INFO severity annotations */
  info_count?: number;
  /** One-sentence next action for billing staff */
  next_action?: string | null;
  /** Priority level: urgent, action_needed, monitor, or none */
  next_action_priority?: string | null;
  /** Parent claim ID for corrections/voids */
  parent_claim_id?: string | null;
  /** Patient control number (PCN) */
  patient_control_number?: string | null;
  /** Patient ID */
  patient_id?: string | null;
  /** Patient display name (enriched) */
  patient_name?: string | null;
  /** Patient responsibility amount from ERA */
  patient_responsibility_cents?: number | null;
  /** Insurance payer name */
  payer_name?: string | null;
  /** Payer UUID */
  payer_uuid?: string | null;
  /** Top CARC code (e.g., CO-16) */
  primary_denial_code?: string | null;
  /** Human-readable denial reason */
  primary_denial_description?: string | null;
  /** Provider ID */
  provider_id?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** Blocked level: org, entity, or claim_data */
  readiness_blocked_level?: string | null;
  /** Human-readable blocker description */
  readiness_blocked_message?: string | null;
  /** Submission readiness: READY or BLOCKED */
  readiness_status?: string | null;
  /** Service date from */
  service_date_from?: string | null;
  /** Service date to */
  service_date_to?: string | null;
  /** Origin system */
  source_system?: string;
  /** Claim lifecycle status */
  status: string;
  /** When claim was submitted */
  submitted_at?: string | null;
  /** ID of the correction/void claim that supersedes this one */
  superseded_by_claim_id?: string | null;
  /** Message of the highest-severity annotation */
  top_blocker?: string | null;
  /** Total charge amount in cents */
  total_charge_cents?: number | null;
  /** When claim was last updated */
  updated_at: string;
  /** Number of WARNING severity annotations */
  warning_count?: number;
};
export type OrgClaimListResponse = {
  /** List of enriched claim items */
  claims: ClaimListItem[];
  /** Current page number */
  page: number;
  /** Items per page */
  per_page: number;
  /** Total number of claims */
  total: number;
  /** Total number of pages */
  total_pages: number;
};
export type ClaimQueueCounts = {
  /** Draft claims with blockers */
  blocked?: number;
  /** Denied claims */
  denied?: number;
  /** Imported historical claims */
  imported?: number;
  /** Claims needing immediate action */
  needs_attention?: number;
  /** Paid or partially paid claims */
  paid?: number;
  /** Claims ready for submission */
  ready_to_submit?: number;
  /** Claims in-flight (submitted/acknowledged/accepted) */
  submitted?: number;
  /** Total claim count */
  total?: number;
};
export type ClaimDetailLineage = {
  /** IDs of correction/void claims derived from this claim */
  child_claim_ids?: string[];
  /** ID of the original claim this was corrected/voided from */
  parent_claim_id?: string | null;
};
export type OrgClaimDetailResponse = {
  /** Full claim data */
  claim: {
    [key: string]: any;
  };
  /** Parent and child claim relationships */
  lineage: ClaimDetailLineage;
};
export type CptChargeOutput = {
  /** Charge amount in cents */
  charge_cents: number;
  /** Normalized CPT code */
  cpt_code: string;
  /** When the charge was created */
  created_at?: string | null;
  /** Provider ID who owns this charge */
  provider_id: string;
  /** When the charge was last updated */
  updated_at?: string | null;
};
export type CptChargesLookupResponse = {
  /** CPT charges that were found */
  found_charges?: CptChargeOutput[];
  /** Number of charges found */
  found_count: number;
  /** CPT codes that were not found */
  not_found_codes?: string[];
  /** Number of codes not found */
  not_found_count: number;
  /** Provider ID for the lookup */
  provider_id: string;
  /** Total number of CPT codes requested */
  total_requested: number;
};
export type CptChargesLookupRequest = {
  /** List of CPT codes to look up */
  cpt_codes: string[];
};
export type CptChargeResponse = {
  /** Remembered charge amount in cents (e.g., 8550 for $85.50), or null if not found */
  charge_cents?: number | null;
};
export type OrgBillingEncounterResponse = {
  appointment_id?: string | null;
  appointment_info?: {
    [key: string]: any;
  } | null;
  /** Audit quality status: green, yellow, red, or null (no audit) */
  audit_status?: string | null;
  /** Reasons for audit status */
  audit_status_reasons?: string[];
  billable?: boolean;
  /** Canonical encounter identity fields for billing surfaces: DOS, patient, service, provider, and payer. */
  billing_identity?: {
    [key: string]: any;
  } | null;
  canonical_service_type?: {
    [key: string]: any;
  } | null;
  canonical_service_type_slug?: string | null;
  claim_id?: string | null;
  claim_status?: string | null;
  cpt_analysis?: {
    [key: string]: any;
  } | null;
  cpt_codes?: string[];
  created_at?: string | null;
  date_of_service?: string | null;
  encounter_id: string;
  encounter_type?: string | null;
  /** Number of CPT codes with fee schedule matches */
  fee_schedule_line_count?: number;
  /** Total fee schedule amount in cents */
  fee_schedule_total_cents?: number | null;
  has_audit?: boolean;
  has_claim?: boolean;
  icd10_codes?: string[];
  /** Specific missing information items */
  info_missing?: string[];
  /** Information completeness status: green or red */
  info_status?: string;
  is_signed?: boolean;
  last_audit_at?: string | null;
  latest_compliance_pct?: number | null;
  latest_quality_score?: number | null;
  modality?: string | null;
  note_id?: string | null;
  note_ids?: string[];
  outputs?: any[];
  patient_id?: string | null;
  patient_info?: {
    [key: string]: any;
  } | null;
  patient_name?: string | null;
  /** Primary insurance payer name */
  primary_payer_name?: string | null;
  provider_id: string;
  /** Provider billing license state used for fee schedule context */
  provider_license_state?: string | null;
  /** Provider billing license type used for fee schedule context */
  provider_license_type?: string | null;
  provider_name?: string | null;
  /** Composite ready-to-bill status: green, yellow, or red */
  ready_to_bill?: string | null;
  /** Combined reasons from audit and info checks */
  ready_to_bill_reasons?: string[];
  scheduled_for?: string | null;
  /** Best-available service date via waterfall: date_of_service → service_rendered_at → appointment.start_time → scheduled_for → created_at. */
  service_date?: string | null;
  service_rendered_at?: string | null;
  status: string;
  summary?: string | null;
  working_billing_claim?: {
    [key: string]: any;
  } | null;
};
export type OrgBillingEncounterListResponse = {
  /** List of billing encounters */
  encounters: OrgBillingEncounterResponse[];
  /** Current page number */
  page: number;
  /** Items per page */
  per_page: number;
  /** Total number of encounters */
  total: number;
  /** Total number of pages */
  total_pages: number;
};
export type UnifiedEncounterWorklistActions = {
  claim_href?: string | null;
  patient_billing_href?: string | null;
  primary_href: string;
};
export type UnifiedEncounterWorklistAge = {
  anchor?: string | null;
  days?: number | null;
  label: string;
};
export type UnifiedEncounterWorklistClaim = {
  claim_type?: string | null;
  frequency_code?: string | null;
  id?: string | null;
  parent_claim_id?: string | null;
  status?: string | null;
  submitted_at?: string | null;
  superseded_by_claim_id?: string | null;
  total_charge_cents?: number | null;
};
export type UnifiedEncounterFlowAction = {
  label: string;
  owner: string;
  severity: "info" | "warning" | "error";
};
export type FlowSourceRef = {
  id: string;
  type: string;
};
export type UnifiedEncounterFlowStage = {
  attention?: "none" | "info" | "warning" | "error";
  attention_reason?: string | null;
  completed_at?: string | null;
  display_label: string;
  key: "schedule" | "support" | "sign" | "submit" | "settle";
  source_refs?: FlowSourceRef[];
  state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  summary?: string | null;
};
export type UnifiedEncounterWorklistFlow = {
  active_stage: "schedule" | "support" | "sign" | "submit" | "settle";
  active_state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  conflicts?: {
    [key: string]: any;
  }[];
  primary_action?: UnifiedEncounterFlowAction | null;
  stages: UnifiedEncounterFlowStage[];
};
export type UnifiedEncounterIdentityBadge = {
  icon?: string | null;
  key: string;
  label: string;
  tooltip?: string | null;
};
export type UnifiedEncounterWorklistIdentity = {
  badges?: UnifiedEncounterIdentityBadge[];
  billing_codes_label?: string;
  coverage_kind?: string | null;
  encounter_id: string;
  is_self_pay?: boolean;
  member_id?: string | null;
  patient_id?: string | null;
  patient_name: string;
  payer_name: string;
  payer_uuid?: string | null;
  provider_id?: string | null;
  provider_license_label?: string | null;
  provider_name: string;
  service_date?: string | null;
  service_label: string;
};
export type UnifiedEncounterWorklistActivity = {
  at?: string | null;
  kind?: string | null;
  label: string;
  relative_label: string;
  source_id?: string | null;
  source_type?: string | null;
};
export type UnifiedEncounterWorklistMoneyCharge = {
  charged_cents?: number;
  expected_cents?: number | null;
  expected_label?: string | null;
};
export type UnifiedEncounterWorklistPatientResponsibility = {
  collected_cents?: number;
  confirmed_cents?: number;
  credit_cents?: number;
  estimated_cents?: number;
  outstanding_cents?: number;
};
export type UnifiedEncounterWorklistMoneyReconciliation = {
  active_invoice_cents?: number;
  active_invoice_ids?: string[];
  collected_cents?: number;
  confirmed_cents?: number;
  confirmed_line_ids?: string[];
  credit_cents?: number;
  estimate_line_ids?: string[];
  estimated_cents?: number;
  explanation?: string | null;
  headline?: string | null;
  payment_entry_ids?: string[];
  recommended_action?: string | null;
  remaining_due_cents?: number;
  stale_invoice_ids?: string[];
  state: string;
};
export type UnifiedEncounterWorklistMoneySecondary = {
  amount_cents?: number;
  kind: string;
  label: string;
};
export type UnifiedEncounterWorklistMoney = {
  amount_cents?: number;
  charge?: UnifiedEncounterWorklistMoneyCharge | null;
  expected_allowed_cents?: number | null;
  expected_allowed_label?: string | null;
  expected_collection_cents?: number | null;
  kind: string;
  label: string;
  patient_responsibility?: UnifiedEncounterWorklistPatientResponsibility | null;
  reconciliation?: UnifiedEncounterWorklistMoneyReconciliation | null;
  secondary?: UnifiedEncounterWorklistMoneySecondary | null;
  undercharge_risk?: boolean;
};
export type UnifiedEncounterWorklistSignal = {
  detail?: string | null;
  label: string;
  owner: "front_desk" | "clinician" | "biller" | "payer" | "patient" | "none";
  severity: "info" | "warning" | "error" | "success";
  stale?: boolean;
  work_state: "all" | "action" | "waiting" | "clear";
};
export type UnifiedEncounterWorklistSupport = {
  eligibility_snapshot_id?: string | null;
  readiness?: string | null;
  readiness_label?: string | null;
  status?: string | null;
};
export type UnifiedEncounterWorklistItem = {
  actions: UnifiedEncounterWorklistActions;
  age: UnifiedEncounterWorklistAge;
  /** Whether this encounter's patient is flagged to bill with JotPsych */
  bill_with_jotpsych_resolved?: boolean;
  claim: UnifiedEncounterWorklistClaim;
  encounter_id: string;
  flow: UnifiedEncounterWorklistFlow;
  id: string;
  identity: UnifiedEncounterWorklistIdentity;
  last_activity: UnifiedEncounterWorklistActivity;
  money: UnifiedEncounterWorklistMoney;
  provenance?: {
    [key: string]: any;
  };
  signal: UnifiedEncounterWorklistSignal;
  support: UnifiedEncounterWorklistSupport;
};
export type UnifiedEncounterWorklistSegment = {
  key: string;
  label: string;
  severity?: string | null;
};
export type UnifiedEncounterWorklistResponse = {
  degraded?: boolean;
  has_more: boolean;
  items: UnifiedEncounterWorklistItem[];
  known_minimum: number;
  page: number;
  per_page: number;
  provenance?: {
    [key: string]: any;
  };
  segments: UnifiedEncounterWorklistSegment[];
  stage_segments: UnifiedEncounterWorklistSegment[];
  summary: string;
};
export type ClaimReferenceResponse = {
  claim_type?: string | null;
  created_at?: string | null;
  id: string;
  insurance_payer_name?: string | null;
  status: string;
  submitted_at?: string | null;
  total_charge_cents?: number;
};
export type NoteAuditSummary = {
  completed_at?: string | null;
  compliance_improvement?: number | null;
  current_revision?: number | null;
  encounter_id?: string | null;
  first_audit_at?: string | null;
  is_completed?: boolean;
  last_audit_at?: string | null;
  latest_compliance_pct?: number | null;
  latest_cpt_match?: boolean | null;
  latest_quality_score?: number | null;
  latest_status?: string | null;
  note_audit_id: string;
  note_id: string;
  note_title?: string | null;
  patient_name?: string | null;
  provider_name?: string | null;
  quality_improvement?: number | null;
  total_revisions?: number | null;
  user_id?: string | null;
  within_quota?: boolean | null;
};
export type AuditRevisionDetail = {
  audit_data?: {
    [key: string]: any;
  } | null;
  compliance_delta?: number | null;
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean | null;
  cpt_match?: boolean | null;
  created_at?: string | null;
  overall_quality_score?: number | null;
  provider_cpt_codes?: string[] | null;
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  revision?: number | null;
  rules_compliant?: number | null;
  rules_non_compliant?: number | null;
  rules_warning?: number | null;
  status?: string | null;
  target_cpt_codes?: string[] | null;
  target_cpt_source?: string | null;
  trigger?: string | null;
};
export type NoteAuditDetail = {
  audit: NoteAuditSummary;
  current_revision?: AuditRevisionDetail | null;
  patient_name?: string | null;
  provider_name?: string | null;
};
export type EncounterBillingSummary = {
  /** Historical invoices linked to this encounter for event timelines. */
  invoices?: {
    [key: string]: any;
  }[];
  /** Most recent PAYMENT entry date */
  last_payment_date?: string | null;
  /** Encounter-scoped patient ledger entries for event timelines. */
  ledger_entries?: {
    [key: string]: any;
  }[];
  /** Invoice IDs linked to this encounter's charge lines */
  linked_invoice_ids?: string[];
  /** Net encounter-scoped patient balance */
  patient_balance_cents: number;
  /** Highest-priority status across charge_lines */
  patient_due_status: string;
  /** Derived estimate-to-confirmed patient responsibility state for this encounter. */
  patient_responsibility_reconciliation?: {
    [key: string]: any;
  } | null;
  /** Sum of charge_line amounts for this encounter */
  total_charge_cents: number;
  /** Sum of patient PAYMENT entries for this encounter */
  total_paid_cents: number;
  /** Account-level unallocated credit */
  unapplied_credit_cents: number;
};
export type OrgBillingEncounterDetailResponse = {
  analyzed_at?: string | null;
  appointment_id?: string | null;
  appointment_info?: {
    [key: string]: any;
  } | null;
  /** Audit quality status: green, yellow, red, or null (no audit) */
  audit_status?: string | null;
  /** Reasons for audit status */
  audit_status_reasons?: string[];
  billable?: boolean;
  /** Canonical encounter identity fields for billing surfaces: DOS, patient, service, provider, and payer. */
  billing_identity?: {
    [key: string]: any;
  } | null;
  canonical_service_type?: {
    [key: string]: any;
  } | null;
  canonical_service_type_slug?: string | null;
  claim_id?: string | null;
  claim_status?: string | null;
  /** All claim references for this encounter */
  claims?: ClaimReferenceResponse[];
  cpt_codes?: string[];
  created_at?: string | null;
  date_of_service?: string | null;
  /** Full encounter analysis data from cortex */
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  encounter_id: string;
  encounter_type?: string | null;
  /** Number of CPT codes with fee schedule matches */
  fee_schedule_line_count?: number;
  /** Total fee schedule amount in cents */
  fee_schedule_total_cents?: number | null;
  has_claim?: boolean;
  icd10_codes?: string[];
  /** Specific missing information items */
  info_missing?: string[];
  /** Information completeness status: green or red */
  info_status?: string;
  is_signed?: boolean;
  modality?: string | null;
  /** All note audits for this encounter */
  note_audits?: NoteAuditDetail[];
  note_id?: string | null;
  note_ids?: string[];
  outputs?: any[];
  /** Patient financial summary for this encounter. None if no charge_lines exist yet (pre-claim-submission). */
  patient_billing?: EncounterBillingSummary | null;
  patient_id?: string | null;
  patient_info?: {
    [key: string]: any;
  } | null;
  patient_name?: string | null;
  /** Primary insurance payer name */
  primary_payer_name?: string | null;
  provider_id: string;
  /** Provider billing license state used for fee schedule context */
  provider_license_state?: string | null;
  /** Provider billing license type used for fee schedule context */
  provider_license_type?: string | null;
  provider_name?: string | null;
  /** Composite ready-to-bill status: green, yellow, or red */
  ready_to_bill?: string | null;
  /** Combined reasons from audit and info checks */
  ready_to_bill_reasons?: string[];
  scheduled_for?: string | null;
  /** Best-available service date via waterfall: date_of_service → service_rendered_at → appointment.start_time → scheduled_for → created_at. */
  service_date?: string | null;
  service_rendered_at?: string | null;
  status: string;
  summary?: string | null;
  working_billing_claim?: {
    [key: string]: any;
  } | null;
};
export type UnifiedEncounterWorkspaceAction = {
  disabled?: boolean;
  disabled_reason?: string | null;
  intent:
    | "open_panel"
    | "open_claim"
    | "open_cms"
    | "open_note"
    | "open_remittance"
    | "open_balance"
    | "check_coverage"
    | "sign_note"
    | "create_claim"
    | "create_correction_claim"
    | "void_claim"
    | "create_new_original_claim"
    | "scrub_claim"
    | "submit_claim"
    | "record_payment"
    | "send_invoice";
  label: string;
  severity?: "info" | "warning" | "error";
  target_panel?: string | null;
};
export type UnifiedEncounterClaimAnnotationCounts = {
  errors?: number;
  info?: number;
  total?: number;
  warnings?: number;
};
export type AnnotationSeverity = "error" | "warning" | "info";
export type ClaimAnnotation = {
  /** CMS-1500 box number for the related field (e.g., '33A', '23') */
  cms_box?: string | null;
  /** Primary field that this annotation relates to */
  field?: string | null;
  /** The annotation message */
  message: string;
  /** ID of the rule that generated this annotation (if applicable) */
  rule_id?: string | null;
  /** Human-readable name of the rule (if applicable) */
  rule_name?: string | null;
  /** Severity level of the annotation */
  severity: AnnotationSeverity;
};
export type UnifiedEncounterBillingInputs = {
  billing_code_summary?: string | null;
  date_of_service?: string | null;
  encounter_type?: string | null;
  modality?: string | null;
  provider?: {
    [key: string]: any;
  };
  service?: {
    [key: string]: any;
  };
  signed?: boolean;
};
export type FlowSourceRef2 = {
  id: string;
  type: string;
};
export type UnifiedEncounterClaimLine = {
  adjustment_cents?: number | null;
  adjustment_display?: string | null;
  allowed_cents?: number | null;
  allowed_display?: string | null;
  charge_cents?: number | null;
  charge_display?: string | null;
  claim_line_id?: string | null;
  code: string;
  description?: string | null;
  diagnosis_pointers?: string[];
  expected_allowed_cents?: number | null;
  expected_allowed_display?: string | null;
  expected_collection_cents?: number | null;
  expected_collection_display?: string | null;
  expected_contractual_adjustment_cents?: number | null;
  expected_contractual_adjustment_display?: string | null;
  line_control_number?: string | null;
  modifiers?: string[];
  paid_cents?: number | null;
  paid_display?: string | null;
  patient_responsibility_cents?: number | null;
  patient_responsibility_display?: string | null;
  reason?: string | null;
  source_refs?: FlowSourceRef2[];
  status?: string | null;
  undercharge_risk?: boolean;
  units?: number | null;
  warnings?: string[];
};
export type UnifiedEncounterOverviewClaimSummary = {
  accepted_at?: string | null;
  charge?: string;
  charge_cents?: number;
  claim_id?: string | null;
  claim_type?: string | null;
  clearinghouse_status?: string | null;
  crossover_carrier_id?: string | null;
  crossover_carrier_name?: string | null;
  display_id?: string | null;
  expected_allowed?: string | null;
  expected_allowed_cents?: number | null;
  expected_collection?: string | null;
  expected_collection_cents?: number | null;
  expected_contractual_adjustment?: string | null;
  expected_contractual_adjustment_cents?: number | null;
  forwarded_to_secondary?: boolean;
  line_count?: number;
  lines?: UnifiedEncounterClaimLine[];
  patient_control_number?: string | null;
  patient_due?: string;
  patient_due_cents?: number;
  payer?: string | null;
  scrub_status?: string | null;
  secondary_pending?: string;
  secondary_pending_cents?: number;
  status?: string;
  /** Machine-readable claim status used for client state decisions. */
  status_code?: string | null;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
  submitted_at?: string | null;
  summary?: string | null;
  undercharge_risk?: boolean;
};
export type UnifiedEncounterClaimHistoryClaim = {
  claim_id: string;
  claim_type?: string | null;
  correction_eligible?: boolean;
  created_at?: string | null;
  deletable?: boolean;
  delete_disabled_reason?: string | null;
  display_id?: string | null;
  frequency_code?: string | null;
  new_original_available?: boolean;
  original_reference_number?: string | null;
  parent_claim_id?: string | null;
  patient_control_number?: string | null;
  payer_claim_control_number?: string | null;
  payer_name?: string | null;
  payer_responsibility_sequence_code?: string | null;
  primary_claim_id?: string | null;
  status?: string | null;
  status_label?: string | null;
  submitted_at?: string | null;
  superseded_by_claim_id?: string | null;
  total_charge?: string;
  total_charge_cents?: number;
  void_eligible?: boolean;
};
export type UnifiedEncounterClaimHistoryRelationship = {
  from_claim_id: string;
  kind: "correction" | "void" | "new_original_attempt" | "secondary";
  to_claim_id: string;
};
export type UnifiedEncounterClaimHistory = {
  active_claim_id?: string | null;
  claims?: UnifiedEncounterClaimHistoryClaim[];
  relationships?: UnifiedEncounterClaimHistoryRelationship[];
};
export type UnifiedEncounterClaimParticipant = {
  /** Set when the claim renders under another member's NPI per the treating clinician's billing settings (GDN-1926) */
  bill_under_user_id?: string | null;
  cms_boxes?: string[];
  details?: {
    [key: string]: any;
  };
  id?: string | null;
  primary?: string | null;
  secondary?: string | null;
  source?: string | null;
  status?: "default" | "success" | "warning" | "error" | "info";
  /** Clinician who delivered the services when a bill-under override applied */
  treating_provider_name?: string | null;
};
export type UnifiedEncounterClaimParticipants = {
  billing_entity?: UnifiedEncounterClaimParticipant;
  rendering_provider?: UnifiedEncounterClaimParticipant;
  service_facility?: UnifiedEncounterClaimParticipant;
};
export type UnifiedEncounterArtifact = {
  action?: UnifiedEncounterWorkspaceAction | null;
  available?: boolean;
  description?: string | null;
  key: string;
  label: string;
  source_ref?: FlowSourceRef2 | null;
  status?: string | null;
};
export type UnifiedEncounterCoverageSummary = {
  display_label?: string | null;
  is_self_pay?: boolean;
  kind?: string | null;
  member_id?: string | null;
  payer_name?: string | null;
  plan_name?: string | null;
  support_state?: string | null;
};
export type UnifiedEncounterFilingCodePreview = {
  /** Effective claim filing indicator code, e.g. 'FI'. */
  code: string;
  /** Provenance: 'biller_override', 'payer_default', 'insurance_type', or 'fallback'. */
  source: string;
};
export type UnifiedEncounterReadinessItem = {
  detail?: string | null;
  key: string;
  label: string;
  source_refs?: FlowSourceRef2[];
  target_panel?: string | null;
  tone?: "default" | "success" | "warning" | "error" | "info";
  value: string;
};
export type UnifiedEncounterClaimPatient = {
  dob?: string | null;
  id?: string | null;
  identifier?: string | null;
  name?: string | null;
};
export type UnifiedEncounterClaimProblemReason = {
  affected_line_ids?: string[];
  amount_cents?: number | null;
  code?: string | null;
  code_system?: string | null;
  code_system_label?: string | null;
  definition?: string | null;
  description?: string | null;
  display_code?: string | null;
  group_code?: string | null;
  group_code_explanation?: string | null;
  group_code_title?: string | null;
  medium_explanation?: string | null;
  raw_label?: string | null;
  scope?: string;
  short_explanation?: string | null;
  source_label?: string | null;
  source_url?: string | null;
  title?: string | null;
  what_it_means_here?: string | null;
};
export type UnifiedEncounterPostSubmissionClaimLine = {
  adjustment_cents?: number | null;
  adjustment_display?: string | null;
  balance_status?:
    | "balanced"
    | "balanced_with_inference"
    | "unbalanced"
    | "unknown";
  billed_cents?: number | null;
  billed_display?: string | null;
  claim_line_id?: string | null;
  code: string;
  description?: string | null;
  diagnosis_pointers?: string[];
  line_control_number?: string | null;
  modifiers?: string[];
  patient_responsibility_cents?: number | null;
  patient_responsibility_display?: string | null;
  patient_responsibility_source?:
    | ("era_line" | "claim_level_inferred" | "unallocated")
    | null;
  payer_paid_cents?: number | null;
  payer_paid_display?: string | null;
  primary_reason?: UnifiedEncounterClaimProblemReason | null;
  reason_codes?: UnifiedEncounterClaimProblemReason[];
  secondary_pending_cents?: number | null;
  secondary_pending_display?: string | null;
  secondary_pending_source?: ("era_line" | "claim_level_inferred") | null;
  source_refs?: FlowSourceRef2[];
  status?: string;
  units?: number | null;
  unresolved_cents?: number | null;
  unresolved_display?: string | null;
};
export type UnifiedEncounterClaimProblemAffectedLine = {
  adjustment_cents?: number | null;
  billed_cents?: number | null;
  claim_line_id?: string | null;
  cpt?: string | null;
  line_control_number?: string | null;
  modifiers?: string[];
  paid_cents?: number | null;
  patient_responsibility_cents?: number | null;
  reason_codes?: UnifiedEncounterClaimProblemReason[];
};
export type UnifiedEncounterClaimProblemEvidenceLink = {
  id: string;
  label: string;
  type: string;
};
export type UnifiedEncounterClaimProblemFinancials = {
  adjustment_cents?: number | null;
  amount_at_risk_cents?: number | null;
  billed_cents?: number | null;
  patient_responsibility_cents?: number | null;
  payer_paid_cents?: number | null;
};
export type UnifiedEncounterClaimProblemNextAction = {
  confidence_level?: string | null;
  disabled_reason?: string | null;
  label: string;
  owner?: string | null;
  priority?: string | null;
  source?: "deterministic" | "claim_case_review";
};
export type UnifiedEncounterClaimProblemReviewGuidance = {
  action_label?: string | null;
  action_summary?: {
    [key: string]: any;
  } | null;
  confidence_level?: string | null;
  explained_codes?: {
    [key: string]: any;
  }[];
  patient_billing_gate?: {
    [key: string]: any;
  } | null;
  primary_finding?: {
    [key: string]: any;
  } | null;
  problem_explanation?: {
    [key: string]: any;
  } | null;
  recommended_action?: {
    [key: string]: any;
  } | null;
  resolution_path_explanation?: string | null;
  review_id: string;
  root_cause_label?: string | null;
};
export type UnifiedEncounterClaimProblemSummary = {
  affected_lines?: UnifiedEncounterClaimProblemAffectedLine[];
  evidence_links?: UnifiedEncounterClaimProblemEvidenceLink[];
  financials?: UnifiedEncounterClaimProblemFinancials | null;
  headline: string;
  kind:
    | "rejection"
    | "denial"
    | "partial_payment"
    | "reversal"
    | "manual_review"
    | "unknown";
  next_action: UnifiedEncounterClaimProblemNextAction;
  occurred_at?: string | null;
  reason_codes?: UnifiedEncounterClaimProblemReason[];
  reason_of_record?: UnifiedEncounterClaimProblemReason | null;
  review_guidance?: UnifiedEncounterClaimProblemReviewGuidance | null;
  source_kind?: string | null;
  source_label: string;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
  title: string;
};
export type UnifiedEncounterClaimWorkspaceResponse = {
  actions?: UnifiedEncounterWorkspaceAction[];
  annotation_counts?: UnifiedEncounterClaimAnnotationCounts;
  annotations?: ClaimAnnotation[];
  billing_inputs?: UnifiedEncounterBillingInputs;
  claim_header?: UnifiedEncounterOverviewClaimSummary;
  claim_history?: UnifiedEncounterClaimHistory;
  claim_participants?: UnifiedEncounterClaimParticipants;
  cms_artifact?: UnifiedEncounterArtifact | null;
  coverage?: UnifiedEncounterCoverageSummary;
  diagnosis_codes?: string[];
  encounter_id: string;
  /** Effective claim filing indicator + provenance (GDN-2025). */
  filing_code?: UnifiedEncounterFilingCodePreview | null;
  issues?: UnifiedEncounterReadinessItem[];
  lifecycle?: {
    [key: string]: any;
  };
  mode?: "empty" | "draft" | "editable" | "submitted" | "read_only";
  patient?: UnifiedEncounterClaimPatient;
  post_submission_lines?: UnifiedEncounterPostSubmissionClaimLine[];
  pricing?: {
    [key: string]: any;
  };
  problem_summary?: UnifiedEncounterClaimProblemSummary | null;
  selected_claim_id?: string | null;
  service_lines?: UnifiedEncounterClaimLine[];
};
export type WorkingClaimLineItem = {
  /** Charge amount in cents (>= 0), if priced. */
  charge_cents?: number | null;
  /** Billing procedure code in '{SYSTEM}:{CODE}' form, SYSTEM = CPT or HCPCS (e.g. 'CPT:99214', 'HCPCS:H0031'); uppercased and validated. */
  code_id: string;
  /** Subset of the claim-level ICD-10 diagnosis_codes this line links to (CMS-1500 Box 24E). Empty = all claim diagnoses apply. */
  diagnosis_codes?: string[];
  /** Per-modifier provenance; keys must be a subset of modifiers. */
  modifier_sources?: {
    [key: string]:
      | "provider_selected"
      | "ai_recommended"
      | "structured"
      | "carried_forward";
  };
  /** CPT/HCPCS modifiers (max 4), uppercased and de-duplicated. */
  modifiers?: string[];
  /** Provenance of this line: 'provider_selected', 'ai_recommended', 'structured', or 'carried_forward'. */
  source:
    | "provider_selected"
    | "ai_recommended"
    | "structured"
    | "carried_forward";
  /** Billed units for this line (>= 1). */
  units?: number;
};
export type WorkingBillingClaimPutRequest = {
  /** Optional provenance for each diagnosis code. If omitted, all codes are marked provider_selected. */
  diagnosis_code_sources?: {
    [key: string]:
      | "provider_selected"
      | "ai_recommended"
      | "structured"
      | "carried_forward";
  } | null;
  /** ICD-10 diagnosis codes for the claim (max 4 after normalization) */
  diagnosis_codes?: string[];
  /** Optimistic concurrency token. If provided and stale, update returns 409. */
  expected_updated_at?: string | null;
  /** Full replacement list of claim line items */
  line_items?: WorkingClaimLineItem[];
  /** CMS place of service code (e.g. '11', '02') */
  place_of_service?: string | null;
};
export type UnifiedEncounterClaimWorkspaceRefreshRequest = {
  /** Claim to pin the returned workspace to. Must belong to this encounter. The rebuild always targets the encounter's active (non-superseded) claim regardless of this value. */
  claim_id?: string | null;
  /** Optional full-replace working billing claim payload to persist before rebuilding and scrubbing the claim. */
  working_billing_claim?: WorkingBillingClaimPutRequest | null;
};
export type UnifiedEncounterFlowAction2 = {
  label: string;
  owner: string;
  severity: "info" | "warning" | "error";
};
export type FlowSourceRef3 = {
  id: string;
  type: string;
};
export type UnifiedEncounterFlowStage2 = {
  attention?: "none" | "info" | "warning" | "error";
  attention_reason?: string | null;
  completed_at?: string | null;
  display_label: string;
  key: "schedule" | "support" | "sign" | "submit" | "settle";
  source_refs?: FlowSourceRef3[];
  state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  summary?: string | null;
};
export type UnifiedEncounterBillingFlowResponse = {
  active_stage: "schedule" | "support" | "sign" | "submit" | "settle";
  active_state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  conflicts?: {
    [key: string]: any;
  }[];
  encounter_id: string;
  primary_action?: UnifiedEncounterFlowAction2 | null;
  source_states?: {
    [key: string]: any;
  };
  stages: UnifiedEncounterFlowStage2[];
};
export type UnifiedEncounterBalanceBreakdownItem = {
  key: string;
  label: string;
  tone?: "default" | "success" | "warning" | "error" | "info";
  value: string;
  value_cents?: number;
};
export type UnifiedEncounterBalanceSummary = {
  breakdown?: UnifiedEncounterBalanceBreakdownItem[];
  invoice_state?: string;
  last_payment_date?: string | null;
  linked_invoice_ids?: string[];
  paid?: string;
  paid_cents?: number;
  /** Derived patient responsibility reconciliation state comparing eligibility estimates, confirmed ERA responsibility, collected amounts, and active invoice posture. */
  reconciliation?: {
    [key: string]: any;
  } | null;
  remaining?: string;
  remaining_cents?: number;
  responsibility?: string;
  responsibility_cents?: number;
  status?: string;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
};
export type FlowSourceRef4 = {
  id: string;
  type: string;
};
export type UnifiedEncounterClaimLine2 = {
  adjustment_cents?: number | null;
  adjustment_display?: string | null;
  allowed_cents?: number | null;
  allowed_display?: string | null;
  charge_cents?: number | null;
  charge_display?: string | null;
  claim_line_id?: string | null;
  code: string;
  description?: string | null;
  diagnosis_pointers?: string[];
  expected_allowed_cents?: number | null;
  expected_allowed_display?: string | null;
  expected_collection_cents?: number | null;
  expected_collection_display?: string | null;
  expected_contractual_adjustment_cents?: number | null;
  expected_contractual_adjustment_display?: string | null;
  line_control_number?: string | null;
  modifiers?: string[];
  paid_cents?: number | null;
  paid_display?: string | null;
  patient_responsibility_cents?: number | null;
  patient_responsibility_display?: string | null;
  reason?: string | null;
  source_refs?: FlowSourceRef4[];
  status?: string | null;
  undercharge_risk?: boolean;
  units?: number | null;
  warnings?: string[];
};
export type UnifiedEncounterOverviewClaimSummary2 = {
  accepted_at?: string | null;
  charge?: string;
  charge_cents?: number;
  claim_id?: string | null;
  claim_type?: string | null;
  clearinghouse_status?: string | null;
  crossover_carrier_id?: string | null;
  crossover_carrier_name?: string | null;
  display_id?: string | null;
  expected_allowed?: string | null;
  expected_allowed_cents?: number | null;
  expected_collection?: string | null;
  expected_collection_cents?: number | null;
  expected_contractual_adjustment?: string | null;
  expected_contractual_adjustment_cents?: number | null;
  forwarded_to_secondary?: boolean;
  line_count?: number;
  lines?: UnifiedEncounterClaimLine2[];
  patient_control_number?: string | null;
  patient_due?: string;
  patient_due_cents?: number;
  payer?: string | null;
  scrub_status?: string | null;
  secondary_pending?: string;
  secondary_pending_cents?: number;
  status?: string;
  /** Machine-readable claim status used for client state decisions. */
  status_code?: string | null;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
  submitted_at?: string | null;
  summary?: string | null;
  undercharge_risk?: boolean;
};
export type UnifiedEncounterFilingCodePreview2 = {
  /** Effective claim filing indicator code, e.g. 'FI'. */
  code: string;
  /** Provenance: 'biller_override', 'payer_default', 'insurance_type', or 'fallback'. */
  source: string;
};
export type UnifiedEncounterWorkspaceAction2 = {
  disabled?: boolean;
  disabled_reason?: string | null;
  intent:
    | "open_panel"
    | "open_claim"
    | "open_cms"
    | "open_note"
    | "open_remittance"
    | "open_balance"
    | "check_coverage"
    | "sign_note"
    | "create_claim"
    | "create_correction_claim"
    | "void_claim"
    | "create_new_original_claim"
    | "scrub_claim"
    | "submit_claim"
    | "record_payment"
    | "send_invoice";
  label: string;
  severity?: "info" | "warning" | "error";
  target_panel?: string | null;
};
export type UnifiedEncounterWorkspaceMetric = {
  detail?: string | null;
  label: string;
  tone?: "default" | "success" | "warning" | "error" | "info";
  value: string;
};
export type UnifiedEncounterNextActionCard = {
  action?: UnifiedEncounterWorkspaceAction2 | null;
  detail?: string | null;
  evidence_metrics?: UnifiedEncounterWorkspaceMetric[];
};
export type UnifiedEncounterPayerResponseSummary = {
  adjustments?: string;
  adjustments_cents?: number;
  crossover_carrier_id?: string | null;
  crossover_carrier_name?: string | null;
  forwarded_to_secondary?: boolean;
  line_count?: number;
  paid?: string;
  paid_cents?: number;
  patient_responsibility?: string;
  patient_responsibility_cents?: number;
  payer?: string | null;
  payer_control_number?: string | null;
  payment_date?: string | null;
  payment_method?: string | null;
  received_at?: string | null;
  record_count?: number;
  secondary_pending?: string;
  secondary_pending_cents?: number;
  status?: string;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
  summary?: string | null;
  trace?: string | null;
};
export type UnifiedEncounterReadinessItem2 = {
  detail?: string | null;
  key: string;
  label: string;
  source_refs?: FlowSourceRef4[];
  target_panel?: string | null;
  tone?: "default" | "success" | "warning" | "error" | "info";
  value: string;
};
export type UnifiedEncounterTimelineItem = {
  detail?: string | null;
  display_time?: string | null;
  key: string;
  label: string;
  occurred_at?: string | null;
  source_ref?: FlowSourceRef4 | null;
  tone?: "default" | "success" | "warning" | "error" | "info";
};
export type UnifiedEncounterOverviewResponse = {
  balance?: UnifiedEncounterBalanceSummary;
  claim?: UnifiedEncounterOverviewClaimSummary2;
  encounter_id: string;
  /** Effective claim filing indicator + provenance (GDN-2025). */
  filing_code?: UnifiedEncounterFilingCodePreview2 | null;
  lifecycle?: {
    [key: string]: any;
  };
  next_action?: UnifiedEncounterNextActionCard;
  payer_response?: UnifiedEncounterPayerResponseSummary;
  pricing?: {
    [key: string]: any;
  };
  readiness?: UnifiedEncounterReadinessItem2[];
  timeline_preview?: UnifiedEncounterTimelineItem[];
};
export type UnifiedEncounterWorkspaceAction3 = {
  disabled?: boolean;
  disabled_reason?: string | null;
  intent:
    | "open_panel"
    | "open_claim"
    | "open_cms"
    | "open_note"
    | "open_remittance"
    | "open_balance"
    | "check_coverage"
    | "sign_note"
    | "create_claim"
    | "create_correction_claim"
    | "void_claim"
    | "create_new_original_claim"
    | "scrub_claim"
    | "submit_claim"
    | "record_payment"
    | "send_invoice";
  label: string;
  severity?: "info" | "warning" | "error";
  target_panel?: string | null;
};
export type FlowSourceRef5 = {
  id: string;
  type: string;
};
export type UnifiedEncounterLedgerEntry = {
  amount: string;
  amount_cents?: number;
  key: string;
  label: string;
  source_ref?: FlowSourceRef5 | null;
  tone?: "default" | "success" | "warning" | "error" | "info";
};
export type UnifiedEncounterChargePreview = {
  encounter_id: string;
  lines?: UnifiedEncounterLedgerEntry[];
  source?: string;
  status?: string;
  total_due?: string;
  total_due_cents?: number;
};
export type UnifiedEncounterInvoiceSummary = {
  amount: string;
  amount_cents?: number;
  created_at?: string | null;
  delivery_method?: string | null;
  invoice_id: string;
  paid_at?: string | null;
  status: string;
};
export type UnifiedEncounterBalanceBreakdownItem2 = {
  key: string;
  label: string;
  tone?: "default" | "success" | "warning" | "error" | "info";
  value: string;
  value_cents?: number;
};
export type UnifiedEncounterBalanceSummary2 = {
  breakdown?: UnifiedEncounterBalanceBreakdownItem2[];
  invoice_state?: string;
  last_payment_date?: string | null;
  linked_invoice_ids?: string[];
  paid?: string;
  paid_cents?: number;
  /** Derived patient responsibility reconciliation state comparing eligibility estimates, confirmed ERA responsibility, collected amounts, and active invoice posture. */
  reconciliation?: {
    [key: string]: any;
  } | null;
  remaining?: string;
  remaining_cents?: number;
  responsibility?: string;
  responsibility_cents?: number;
  status?: string;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
};
export type UnifiedEncounterPayerResponseSummary2 = {
  adjustments?: string;
  adjustments_cents?: number;
  crossover_carrier_id?: string | null;
  crossover_carrier_name?: string | null;
  forwarded_to_secondary?: boolean;
  line_count?: number;
  paid?: string;
  paid_cents?: number;
  patient_responsibility?: string;
  patient_responsibility_cents?: number;
  payer?: string | null;
  payer_control_number?: string | null;
  payment_date?: string | null;
  payment_method?: string | null;
  received_at?: string | null;
  record_count?: number;
  secondary_pending?: string;
  secondary_pending_cents?: number;
  status?: string;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
  summary?: string | null;
  trace?: string | null;
};
export type UnifiedEncounterPaymentsWorkspaceResponse = {
  actions?: UnifiedEncounterWorkspaceAction3[];
  charge_preview: UnifiedEncounterChargePreview;
  encounter_id: string;
  invoices?: UnifiedEncounterInvoiceSummary[];
  ledger?: UnifiedEncounterLedgerEntry[];
  patient_balance?: UnifiedEncounterBalanceSummary2;
  payer_response?: UnifiedEncounterPayerResponseSummary2;
};
export type EncounterReadinessResponse = {
  /** Audit quality status: green, yellow, red, or null (no audit) */
  audit_status?: string | null;
  /** Reasons for audit status */
  audit_status_reasons?: string[];
  encounter_id: string;
  /** Number of billing codes with fee schedule matches */
  fee_schedule_line_count?: number;
  /** Total fee schedule amount in cents */
  fee_schedule_total_cents?: number | null;
  /** Specific missing information items */
  info_missing?: string[];
  /** Information completeness status: green or red */
  info_status?: string;
  /** Primary insurance payer name */
  primary_payer_name?: string | null;
  /** Composite ready-to-bill status: green, yellow, or red */
  ready_to_bill?: string | null;
  /** Combined reasons from audit and info checks */
  ready_to_bill_reasons?: string[];
};
export type UnifiedEncounterWorkspaceAction4 = {
  disabled?: boolean;
  disabled_reason?: string | null;
  intent:
    | "open_panel"
    | "open_claim"
    | "open_cms"
    | "open_note"
    | "open_remittance"
    | "open_balance"
    | "check_coverage"
    | "sign_note"
    | "create_claim"
    | "create_correction_claim"
    | "void_claim"
    | "create_new_original_claim"
    | "scrub_claim"
    | "submit_claim"
    | "record_payment"
    | "send_invoice";
  label: string;
  severity?: "info" | "warning" | "error";
  target_panel?: string | null;
};
export type FlowSourceRef6 = {
  id: string;
  type: string;
};
export type UnifiedEncounterArtifact2 = {
  action?: UnifiedEncounterWorkspaceAction4 | null;
  available?: boolean;
  description?: string | null;
  key: string;
  label: string;
  source_ref?: FlowSourceRef6 | null;
  status?: string | null;
};
export type UnifiedEncounterClaimHistoryClaim2 = {
  claim_id: string;
  claim_type?: string | null;
  correction_eligible?: boolean;
  created_at?: string | null;
  deletable?: boolean;
  delete_disabled_reason?: string | null;
  display_id?: string | null;
  frequency_code?: string | null;
  new_original_available?: boolean;
  original_reference_number?: string | null;
  parent_claim_id?: string | null;
  patient_control_number?: string | null;
  payer_claim_control_number?: string | null;
  payer_name?: string | null;
  payer_responsibility_sequence_code?: string | null;
  primary_claim_id?: string | null;
  status?: string | null;
  status_label?: string | null;
  submitted_at?: string | null;
  superseded_by_claim_id?: string | null;
  total_charge?: string;
  total_charge_cents?: number;
  void_eligible?: boolean;
};
export type UnifiedEncounterClaimHistoryRelationship2 = {
  from_claim_id: string;
  kind: "correction" | "void" | "new_original_attempt" | "secondary";
  to_claim_id: string;
};
export type UnifiedEncounterClaimHistory2 = {
  active_claim_id?: string | null;
  claims?: UnifiedEncounterClaimHistoryClaim2[];
  relationships?: UnifiedEncounterClaimHistoryRelationship2[];
};
export type UnifiedEncounterFlowAction3 = {
  label: string;
  owner: string;
  severity: "info" | "warning" | "error";
};
export type UnifiedEncounterFlowStage3 = {
  attention?: "none" | "info" | "warning" | "error";
  attention_reason?: string | null;
  completed_at?: string | null;
  display_label: string;
  key: "schedule" | "support" | "sign" | "submit" | "settle";
  source_refs?: FlowSourceRef6[];
  state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  summary?: string | null;
};
export type UnifiedEncounterBillingFlowResponse2 = {
  active_stage: "schedule" | "support" | "sign" | "submit" | "settle";
  active_state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  conflicts?: {
    [key: string]: any;
  }[];
  encounter_id: string;
  primary_action?: UnifiedEncounterFlowAction3 | null;
  source_states?: {
    [key: string]: any;
  };
  stages: UnifiedEncounterFlowStage3[];
};
export type UnifiedEncounterIdentityBadge2 = {
  icon?: string | null;
  key: string;
  label: string;
  tooltip?: string | null;
};
export type UnifiedEncounterIdentityItem = {
  badges?: UnifiedEncounterIdentityBadge2[];
  entity_id?: string | null;
  key: "dos" | "patient" | "service" | "provider" | "payer";
  label: string;
  link_intent?:
    | ("encounter" | "patient" | "provider" | "payer" | "service")
    | null;
  primary: string;
  secondary?: string | null;
};
export type UnifiedEncounterHeaderIdentity = {
  items: UnifiedEncounterIdentityItem[];
};
export type UnifiedEncounterHeaderAction = {
  intent?:
    | (
        | "open_panel"
        | "open_claim"
        | "open_cms"
        | "open_note"
        | "open_remittance"
        | "open_balance"
        | "check_coverage"
        | "sign_note"
        | "create_claim"
        | "create_correction_claim"
        | "void_claim"
        | "create_new_original_claim"
        | "scrub_claim"
        | "submit_claim"
        | "record_payment"
        | "send_invoice"
      )
    | null;
  label: string;
  owner?: string | null;
  severity?: "info" | "warning" | "error";
  target_stage?: ("schedule" | "support" | "sign" | "submit" | "settle") | null;
};
export type UnifiedEncounterHeaderChip = {
  color?: "default" | "primary" | "success" | "warning" | "error" | "info";
  label: string;
  variant?: "filled" | "outlined" | "soft";
};
export type UnifiedEncounterHeader = {
  flow: UnifiedEncounterBillingFlowResponse2;
  identity: UnifiedEncounterHeaderIdentity;
  primary_action?: UnifiedEncounterHeaderAction | null;
  status_chips?: UnifiedEncounterHeaderChip[];
  title: string;
};
export type UnifiedEncounterTimelineItem2 = {
  detail?: string | null;
  display_time?: string | null;
  key: string;
  label: string;
  occurred_at?: string | null;
  source_ref?: FlowSourceRef6 | null;
  tone?: "default" | "success" | "warning" | "error" | "info";
};
export type UnifiedEncounterBillingResponse = {
  artifacts?: UnifiedEncounterArtifact2[];
  claim_history?: UnifiedEncounterClaimHistory2;
  debug?: {
    [key: string]: any;
  };
  encounter_id: string;
  header: UnifiedEncounterHeader;
  linked_refs?: FlowSourceRef6[];
  timeline?: UnifiedEncounterTimelineItem2[];
};
export type BaselineRateResponse = {
  /** Charge amount in cents */
  charge_cents: number;
  /** Billing code ID (e.g., 'CPT:90834') */
  code_id: string;
  /** Legacy CPT code (e.g., '90834') */
  cpt_code: string;
  /** Date this rate takes effect */
  effective_date: string;
  /** Fee schedule entry ID */
  id: string;
};
export type BaselineRatesGetResponse = {
  /** Number of rates returned */
  count: number;
  /** Organization ID */
  organization_id: string;
  /** Current baseline rates */
  rates?: BaselineRateResponse[];
};
export type BaselineRateUpsertResultItem = {
  /** Charge amount in cents */
  charge_cents: number;
  /** Billing code ID (e.g., 'CPT:90834') */
  code_id: string;
  /** Legacy CPT code (e.g., '90834') */
  cpt_code: string;
  /** True if newly created, False if updated */
  created: boolean;
  /** Date this rate takes effect */
  effective_date: string;
  /** Fee schedule entry ID */
  id: string;
};
export type BaselineRatesUpsertResponse = {
  /** Number of new rates created */
  created_count: number;
  /** Organization ID */
  organization_id: string;
  /** Upserted rates with created/updated flags */
  rates?: BaselineRateUpsertResultItem[];
  /** Number of existing rates updated */
  updated_count: number;
};
export type BaselineRateItem = {
  /** Charge amount in cents (e.g., 15000 for $150.00) */
  charge_cents: number;
  /** Billing code ID (e.g., 'CPT:90834', 'HCPCS:H0031') */
  code_id?: string | null;
  /** Legacy CPT code (e.g., '90834'). Use code_id instead. */
  cpt_code?: string | null;
};
export type BaselineRatesUpsertRequest = {
  /** Date these rates take effect (defaults to today) */
  effective_date?: string | null;
  /** List of billing codes and their charge amounts */
  rates: BaselineRateItem[];
};
export type BaselineRateDeleteResponse = {
  /** Billing code ID that was deleted */
  code_id: string;
  /** Whether deletion was successful */
  deleted: boolean;
};
export type FeeScheduleImportResponse = {
  /** Effective date applied to all imported rows */
  effective_date: string;
  /** Resolved local payer UUID, or null if not matched */
  payer_id?: string | null;
  /** Extracted payer name from document */
  payer_name?: string | null;
  /** Newly created rows */
  rows_created: number;
  /** Total rows written (created + updated) */
  rows_imported: number;
  /** Rows skipped (invalid code_id, zero charge, or error) */
  rows_skipped: number;
  /** Updated existing rows */
  rows_updated: number;
};
export type FeeScheduleRowCorrectionItem = {
  /** Charge amount in cents (e.g., 12000 for $120.00) */
  charge_cents: number;
  /** Billing code ID (e.g., 'CPT:99213', 'HCPCS:H0031') */
  code_id: string;
  /** Rate-affecting modifiers (e.g., {'modifier': 'HO'}) or {} for default */
  modifiers?: {
    [key: string]: any;
  };
};
export type FeeScheduleImportRequest = {
  /** Override extracted effective date. Defaults to date in extraction or today. */
  effective_date?: string | null;
  /** ID of the ClinicDocumentExtractionResult to import from (task='fee_schedule') */
  extraction_result_id: string;
  /** Local payer UUID to use when importing payer expected rates. */
  payer_id?: string | null;
  /** standard_charge imports global claim charges; payer_expected_rate imports payer-specific expected allowed amounts. */
  rate_purpose?: "standard_charge" | "payer_expected_rate";
  /** User-corrected rows. If provided, replaces all extracted rows. */
  rows?: FeeScheduleRowCorrectionItem[] | null;
};
export type PayerExpectedRateResponse = {
  /** Billing code ID (e.g., 'CPT:90834') */
  code_id: string;
  /** Legacy CPT code (e.g., '90834') */
  cpt_code: string;
  /** Date this rate takes effect */
  effective_date: string;
  /** Expected payer allowed/contracted amount in cents */
  expected_allowed_cents: number;
  /** Fee schedule entry ID */
  id: string;
  /** Payer ID */
  payer_id: string;
};
export type PayerExpectedRatesGetResponse = {
  /** Number of rates returned */
  count: number;
  /** Organization ID */
  organization_id: string;
  /** Payer ID */
  payer_id: string;
  rates?: PayerExpectedRateResponse[];
};
export type PayerExpectedRateUpsertResultItem = {
  /** Billing code ID (e.g., 'CPT:90834') */
  code_id: string;
  /** Legacy CPT code (e.g., '90834') */
  cpt_code: string;
  /** True if newly created, False if updated */
  created: boolean;
  /** Date this rate takes effect */
  effective_date: string;
  /** Expected payer allowed/contracted amount in cents */
  expected_allowed_cents: number;
  /** Fee schedule entry ID */
  id: string;
  /** Payer ID */
  payer_id: string;
};
export type PayerExpectedRatesUpsertResponse = {
  /** Number of new rates created */
  created_count: number;
  /** Organization ID */
  organization_id: string;
  /** Payer ID */
  payer_id: string;
  rates?: PayerExpectedRateUpsertResultItem[];
  /** Number of existing rates updated */
  updated_count: number;
};
export type PayerExpectedRateItem = {
  /** Billing code ID (e.g., 'CPT:90834', 'HCPCS:H0031') */
  code_id?: string | null;
  /** Legacy CPT code (e.g., '90834'). Use code_id instead. */
  cpt_code?: string | null;
  /** Expected payer allowed/contracted amount in cents */
  expected_allowed_cents: number;
};
export type PayerExpectedRatesUpsertRequest = {
  /** Date these rates take effect (defaults to today) */
  effective_date?: string | null;
  /** List of billing codes and expected allowed amounts */
  rates: PayerExpectedRateItem[];
};
export type PayerExpectedRateDeleteResponse = {
  /** Billing code ID that was deleted */
  code_id: string;
  /** Whether deletion was successful */
  deleted: boolean;
  /** Payer ID */
  payer_id: string;
};
export type OrgInvoiceResponse = {
  /** Total amount in cents */
  amount_cents: number;
  /** Invoice creation timestamp */
  created_at: string;
  /** Invoice description */
  description?: string | null;
  /** Linked encounter ID */
  encounter_id?: string | null;
  /** Internal invoice UUID */
  id: string;
  /** When the invoice was paid */
  paid_at?: string | null;
  /** Patient UUID */
  patient_id: string;
  /** Linked ERA remittance claim ID */
  remittance_claim_id?: string | null;
  /** Invoice status */
  status: string;
  /** Stripe invoice ID */
  stripe_invoice_id: string;
};
export type OrgInvoiceListResponse = {
  /** List of invoices */
  invoices?: OrgInvoiceResponse[];
};
export type LedgerEntryItem = {
  /** Positive = increases A/R, negative = decreases */
  amount_cents: number;
  created_at: string;
  description?: string | null;
  encounter_id?: string | null;
  entry_id: string;
  /** charge, payment, adjustment, transfer, etc. */
  entry_type: string;
  /** payer or patient */
  party_type: string;
  source_id?: string | null;
  /** claim_submission, era_posting, stripe_webhook, etc. */
  source_type: string;
};
export type PatientBalanceResponse = {
  /** Paginated ledger entries */
  entries?: LedgerEntryItem[];
  /** Current page */
  page?: number;
  /** Null if no billing account exists yet */
  patient_billing_account_id?: string | null;
  patient_id: string;
  /** Items per page */
  per_page?: number;
  /** Total number of entries */
  total?: number;
  /** Positive = patient owes, negative = credit */
  total_balance_cents: number;
  /** Total pages */
  total_pages?: number;
};
export type RecordPaymentResponse = {
  /** True if payment was allocated to charge_lines */
  allocated: boolean;
  /** Amount recorded in cents */
  amount_cents: number;
  /** ID of the COPAY_ESTIMATED charge_line created when ``create_charge=true`` was passed. Null otherwise. */
  charge_line_id?: string | null;
  /** ID of the created ledger entry */
  ledger_entry_id: string;
};
export type RecordPaymentRequest = {
  /** Payment amount in cents */
  amount_cents: number;
  /** Explicit charge_line_ids this payment should cover. Overrides encounter_id allocation when provided. */
  charge_line_ids?: string[] | null;
  /** When the collection actually happened. Defaults to now if omitted. Backdates the ledger entry — and the new charge_line when ``create_charge=true``. Must include a timezone offset. */
  collected_at?: string | null;
  /** When true, creates a fresh COPAY_ESTIMATED charge_line for ``amount_cents`` on ``encounter_id`` before posting the payment. Use this for external copay collections where no charge exists yet (worklist log-collection CTA). */
  create_charge?: boolean;
  /** Required when ``create_charge=true`` (the new charge is scoped here). Optional otherwise — when set, the payment allocates against open charge_lines on this encounter. */
  encounter_id?: string | null;
  /** Optional note about the payment */
  note?: string | null;
  /** Free-text payment method label (cash, check, Square, etc.). Informational only — used in the entry description. */
  payment_method?: string | null;
  /** Check #, receipt #, or external transaction reference. Used to build the dedup ``source_id`` (``manual:{reference_number}``). If omitted BE generates a uuid — pass a stable value when retry-safety matters. */
  reference_number?: string | null;
};
export type WriteOffResponse = {
  /** Amount written off in cents */
  amount_cents: number;
  /** Number of charge lines transitioned to WRITTEN_OFF */
  charge_lines_written_off: number;
  /** ID of the created ledger entry */
  ledger_entry_id: string;
};
export type WriteOffRequest = {
  /** Write-off amount in cents */
  amount_cents: number;
  /** Explicit charge line IDs to write off (overrides encounter_id) */
  charge_line_ids?: string[] | null;
  /** Scope write-off to an encounter's charge lines */
  encounter_id?: string | null;
  /** Optional free-text note */
  note?: string | null;
  /** Reason category: hardship, bad_debt, courtesy, other */
  reason: "hardship" | "bad_debt" | "courtesy" | "other";
};
export type RemittanceListItem = {
  /** Check number or EFT trace number */
  check_or_eft_trace_number: string;
  /** Total claims in this ERA */
  claim_count?: number;
  created_at?: string | null;
  /** Claims with status code 4 (denied) */
  denied_claim_count?: number;
  /** Claims matched to internal records */
  matched_claim_count?: number;
  payee_name?: string | null;
  payer_identifier?: string | null;
  payer_name?: string | null;
  /** Date the payer issued payment (from 835 DTM*405) */
  payment_date?: string | null;
  /** CHK (check) or ACH (electronic) */
  payment_method_code?: string | null;
  remittance_id: string;
  /** Claims with status code 22 (reversal) */
  reversal_count?: number;
  source_system?: string | null;
  /** Sum of total_claim_charge_amount_cents across all claims */
  total_charge_cents?: number;
  /** Sum of patient_responsibility_amount_cents across all claims */
  total_patient_responsibility_cents?: number;
  /** Total payment in cents across all claims */
  total_payment_amount_cents?: number | null;
};
export type RemittanceListItemResponse = {
  /** Current page number (1-based) */
  page: number;
  /** Number of items per page */
  per_page: number;
  remittances?: RemittanceListItem[];
  /** Total number of remittances matching filters */
  total: number;
  /** Total number of pages available */
  total_pages: number;
};
export type RemittanceQueueCounts = {
  /** Total remittances matching filters */
  all?: number;
  /** Remittances where all claims are matched and processed */
  clean?: number;
  /** Remittances with at least one denied claim */
  has_denials?: number;
  /** Remittances from historical imports */
  imported?: number;
  /** Remittances with at least one reversal */
  reversals?: number;
};
export type StatementHistoryItem = {
  completed_at?: string | null;
  created_at?: string | null;
  error_count?: number;
  statement_run_id: string;
  status: string;
  total_amount_cents: number;
  total_invoices_created: number;
  trigger_type: string;
  triggered_by?: string | null;
};
export type StatementHistoryListResponse = {
  items?: StatementHistoryItem[];
  /** Current page (1-based) */
  page: number;
  /** Items per page */
  per_page: number;
  /** Total items matching filters */
  total: number;
  /** Total pages */
  total_pages: number;
};
export type StatementChargeLineItem = {
  billing_code?: string | null;
  charge_line_id: string;
  description?: string | null;
  encounter_id?: string | null;
  patient_due_amount_cents?: number;
};
export type StatementQueueItem = {
  balance_cents: number;
  /** Eligible charge_line IDs — pass these to Send Invoice for allocation */
  charge_line_ids?: string[];
  created_at?: string | null;
  encounter_count: number;
  /** Breakdown of eligible charges for review */
  line_items?: StatementChargeLineItem[];
  patient_billing_account_id: string;
  patient_id: string;
  patient_name: string;
  statement_run_id: string;
  trigger_type: string;
};
export type StatementQueueListResponse = {
  items?: StatementQueueItem[];
  /** Current page (1-based) */
  page: number;
  /** Items per page */
  per_page: number;
  /** Total items matching filters */
  total: number;
  /** Total pages */
  total_pages: number;
};
export type AppointmentLabel = {
  /** Label color token at sync time. */
  color?: string;
  /** Source group ID, or None for a standalone label. */
  label_group_id?: string | null;
  /** Source label ID. */
  label_id: string;
  /** Label display name at sync time. */
  name: string;
};
export type SessionBillingLineItem = {
  /** Procedure code in '{SYSTEM}:{CODE}' form, e.g. CPT:99213. */
  code_id: string;
  modifiers?: string[];
  units?: number;
};
export type SessionBilling = {
  line_items?: SessionBillingLineItem[];
  place_of_service?: string | null;
};
export type AppointmentResponseBase = {
  /** Appointment ID */
  appointment_id: string;
  /** Optional cancellation reason */
  cancellation_reason?: string | null;
  /** Source surface or workflow for the cancellation */
  cancellation_source?: string | null;
  /** Timestamp when appointment was intentionally cancelled */
  cancelled_at?: string | null;
  /** Actor type that cancelled the appointment */
  cancelled_by_actor_type?: string | null;
  /** User ID of the actor who cancelled the appointment */
  cancelled_by_user_id?: string | null;
  /** Timestamp when patient was checked in */
  checked_in_at?: string | null;
  /** Timestamp when visit was checked out */
  checked_out_at?: string | null;
  /** Color for appointment display (inherited from encounter type) */
  color?: string | null;
  /** Patient confirmation status (scheduled, cancelled, reschedule_requested, confirmed) */
  confirmation_status?: string | null;
  /** Optional reason for the confirmation-status change */
  confirmation_status_change_reason?: string | null;
  /** Source surface or workflow for the confirmation-status change */
  confirmation_status_change_source?: string | null;
  /** Timestamp of the last confirmation-status transition */
  confirmation_status_changed_at?: string | null;
  /** Actor type that changed the confirmation status */
  confirmation_status_changed_by_actor_type?: string | null;
  /** User ID of the actor that changed the confirmation status */
  confirmation_status_changed_by_user_id?: string | null;
  /** Creation timestamp */
  created_at: string;
  /** Daily.co room metadata for telehealth appointments (room_name, room_url, etc.) */
  daily_room_metadata?: {
    [key: string]: any;
  } | null;
  /** Timestamp when appointment was deleted from the schedule */
  deleted_at?: string | null;
  /** Calculated display title combining patient name and encounter type */
  display_title?: string | null;
  /** Appointment duration in minutes */
  duration: number;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID */
  encounter_type_id?: string | null;
  /** Form rules for this appointment */
  form_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Practice-defined labels assigned to this appointment (GDN-2018). */
  labels?: AppointmentLabel[];
  /** Flexible metadata for additional appointment data (e.g., suggested_action_id) */
  metadata?: {
    [key: string]: any;
  };
  /** Scheduled visit modality override */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Whether patient did not show up for appointment */
  no_showed?: boolean;
  /** Free-form notes for this appointment */
  notes?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Whether rules are locked from being overridden by defaults */
  override_defaults?: boolean;
  /** Provider ID. None for unassigned appointments. */
  provider_id?: string | null;
  /** Reminder rules for this appointment */
  reminder_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Whether rules are locked from being updated */
  rules_locked?: boolean;
  /** Series ID if part of a recurring series */
  series_id?: string | null;
  /** Session billing projection for this appointment */
  session_billing?: SessionBilling | null;
  /** Appointment start time */
  start_time: string;
  /** Appointment status */
  status: string;
  /** Optional reason for the slot-status change */
  status_change_reason?: string | null;
  /** Source surface or workflow for the slot-status change */
  status_change_source?: string | null;
  /** Timestamp of the last slot-status transition */
  status_changed_at?: string | null;
  /** Actor type that changed the slot status */
  status_changed_by_actor_type?: string | null;
  /** User ID of the actor that changed the slot status */
  status_changed_by_user_id?: string | null;
  /** Whether this is a telehealth/virtual appointment */
  telehealth?: boolean | null;
  /** Template ID associated with encounter type */
  template_id?: string | null;
  /** Appointment title */
  title?: string | null;
  /** Last update timestamp */
  updated_at: string;
  /** Whether this appointment should use JotMeet */
  use_jotmeet?: boolean | null;
  /** Visit lifecycle status (not_started, checked_in, in_progress, checked_out, no_show) */
  visit_status?: string;
  /** Optional reason for the visit-status change */
  visit_status_change_reason?: string | null;
  /** Source surface or workflow for the visit-status change */
  visit_status_change_source?: string | null;
  /** Timestamp of the last visit-status transition */
  visit_status_changed_at?: string | null;
  /** Actor type that changed the visit status */
  visit_status_changed_by_actor_type?: string | null;
  /** User ID of the actor that changed the visit status */
  visit_status_changed_by_user_id?: string | null;
};
export type ClaimReference = {
  /** Claim type (original, corrected, void) */
  claim_type?: string | null;
  /** When the claim was created */
  created_at?: string | null;
  /** Claim UUID */
  id: string;
  /** Insurance payer name for display */
  insurance_payer_name?: string | null;
  /** Claim status (draft, processing, ready, submitted, acknowledged, accepted, rejected) */
  status: string;
  /** When the claim was submitted */
  submitted_at?: string | null;
  /** Total charges in cents */
  total_charge_cents?: number;
};
export type ComputedDefaults = {
  /** Default values for attestation checkboxes */
  attestations?: {
    [key: string]: any;
  } | null;
  /** Default CPT codes from encounter type */
  cpt_codes?: string[];
  /** Default ICD-10 codes from last patient encounter */
  icd10_codes?: string[];
  /** Default modality */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Default place of service code */
  place_of_service?: string | null;
};
export type DocumentCountsMap = {
  /** Map of document type to count */
  counts: {
    [key: string]: number;
  };
  /** Total count of all documents */
  total: number;
};
export type DocumentSummary = {
  /** Count of input documents by type */
  input_counts: DocumentCountsMap;
  /** Count of output documents by type */
  output_counts: DocumentCountsMap;
};
export type EncounterDocumentReference = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Encounter document ID */
  encounter_document_id: string;
  /** Output status */
  status?: "pending" | "completed";
  /** Document title for display */
  title?: string | null;
  /** Document type */
  type: "text" | "recording" | "document" | "note";
};
export type JotDocReference = {
  /** Creation timestamp */
  created_at?: string | null;
  /** JotDoc ID (None for pending outputs) */
  jotdoc_id?: string | null;
  /** Output status */
  status?: "pending" | "completed";
  /** Task ID for tracking (optional, for debugging) */
  task_id?: string | null;
  /** Thread ID for building SSE stream URL */
  thread_id?: string | null;
  /** Document title */
  title?: string | null;
  /** Document type */
  type?: string;
};
export type InsuranceSummary = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Display-ready coverage label, e.g. payer name or Self-pay */
  display_label?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** True when the patient is explicitly designated self-pay */
  is_self_pay?: boolean;
  /** Coverage kind: insurance, self_pay, other */
  kind?: string;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  /** True if the patient has a phone or email a reminder could be delivered to. None when unknown (patient not fully loaded). */
  reminder_reachable?: boolean | null;
  telephone?: string | null;
};
export type EncounterBillingSummary2 = {
  /** Historical invoices linked to this encounter for event timelines. */
  invoices?: {
    [key: string]: any;
  }[];
  /** Most recent PAYMENT entry date */
  last_payment_date?: string | null;
  /** Encounter-scoped patient ledger entries for event timelines. */
  ledger_entries?: {
    [key: string]: any;
  }[];
  /** Invoice IDs linked to this encounter's charge lines */
  linked_invoice_ids?: string[];
  /** Net encounter-scoped patient balance */
  patient_balance_cents: number;
  /** Highest-priority status across charge_lines */
  patient_due_status: string;
  /** Derived estimate-to-confirmed patient responsibility state for this encounter. */
  patient_responsibility_reconciliation?: {
    [key: string]: any;
  } | null;
  /** Sum of charge_line amounts for this encounter */
  total_charge_cents: number;
  /** Sum of patient PAYMENT entries for this encounter */
  total_paid_cents: number;
  /** Account-level unallocated credit */
  unapplied_credit_cents: number;
};
export type WorkingBillingClaimLineItemResponse = {
  /** Charge amount in cents for the line item */
  charge_cents?: number | null;
  /** Billing code identifier */
  code_id?: string | null;
  /** Subset of claim-level diagnosis codes this line links to. Empty = all apply. */
  diagnosis_codes?: string[];
  /** Provenance for each modifier, keyed by modifier code */
  modifier_sources?: {
    [key: string]:
      | "provider_selected"
      | "ai_recommended"
      | "structured"
      | "carried_forward";
  };
  modifiers?: string[];
  /** Whether this line item came from provider edits or AI */
  source?:
    | (
        | "provider_selected"
        | "ai_recommended"
        | "structured"
        | "carried_forward"
      )
    | null;
  /** Units billed */
  units?: number | null;
};
export type WorkingBillingClaimResponse = {
  created_at?: string | null;
  /** For diagnosis codes with source 'structured', the originating patient_diagnosis_id, keyed by normalized ICD-10 code. */
  diagnosis_code_patient_diagnosis_ids?: {
    [key: string]: string;
  };
  /** Provenance for each diagnosis code, keyed by normalized ICD-10 code. 'structured' = selected from the patient's chart, 'carried_forward' = copied from a prior encounter, 'ai_recommended' = LLM-proposed, 'provider_selected' = provider edit. */
  diagnosis_code_sources?: {
    [key: string]:
      | "provider_selected"
      | "ai_recommended"
      | "structured"
      | "carried_forward";
  };
  diagnosis_codes?: string[];
  encounter_id?: string | null;
  line_items?: WorkingBillingClaimLineItemResponse[];
  organization_id?: string | null;
  place_of_service?: string | null;
  updated_at?: string | null;
};
export type EncounterResponse = {
  /** Associated appointment if any */
  appointment?: AppointmentResponseBase | null;
  /** Flexible attestation data */
  attestations?: {
    [key: string]: any;
  } | null;
  /** Whether the current user can delete transcripts (owner or org admin) */
  can_delete_transcripts?: boolean | null;
  /** Associated claims for this encounter (all versions: original, corrected, void) */
  claims?: ClaimReference[] | null;
  /** Suggested default values based on patient, encounter_type, and modality. Frontend can apply these when appropriate. */
  computed_defaults?: ComputedDefaults | null;
  /** CPT codes selected for this encounter */
  cpt_codes?: string[];
  /** Creation timestamp */
  created_at: string;
  /** Canonical billing date (CMS-1500 Box 24A) */
  date_of_service?: string | null;
  /** Summary of document counts */
  document_summary?: DocumentSummary | null;
  /** Encounter analysis payload if available */
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  /** Encounter ID */
  encounter_id: string;
  /** Encounter type */
  encounter_type?: string | null;
  /** Encounter type ID (from the linked appointment, if any) */
  encounter_type_id?: string | null;
  /** Encounter end time */
  end_time?: string | null;
  /** ICD-10 diagnosis codes for billing (max 4, first is primary) */
  icd10_codes?: string[];
  /** Input documents or recordings */
  inputs?: EncounterDocumentReference[];
  /** How the encounter was conducted */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Last modification timestamp */
  modified_at?: string | null;
  /** Legacy note ID */
  note_id?: string | null;
  /** Note title */
  note_title?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Output documents or notes */
  outputs?: (EncounterDocumentReference | JotDocReference)[];
  /** Associated patient information */
  patient?: PatientInfo | null;
  /** Patient financial summary for this encounter. None if no charge_lines exist yet (pre-claim-submission). */
  patient_billing?: EncounterBillingSummary2 | null;
  /** Patient ID */
  patient_id?: string | null;
  /** CMS place of service code (e.g., '11', '10', '02') */
  place_of_service?: string | null;
  /** Provider ID */
  provider_id: string;
  /** When the encounter was scheduled for. Canonical sort key for encounter lists; UI should display this so the visible date matches the order. */
  scheduled_for?: string | null;
  /** Resolved service date — the single date any UI should display for 'when the service happened'. Output of resolve_encounter_service_date() (waterfall: date_of_service -> service_rendered_at -> start_time -> scheduled_for -> created_at). Read-only; prefer this over picking a raw date field. */
  service_date?: string | null;
  /** Timestamp confirming service was rendered */
  service_rendered_at?: string | null;
  /** Encounter start time */
  start_time?: string | null;
  /** Encounter status */
  status: string;
  /** Template ID */
  template_id?: string | null;
  /** Whether transcripts have been deleted for this encounter */
  transcripts_deleted?: boolean;
  /** Last update timestamp */
  updated_at: string;
  /** Canonical encounter-level working billing claim (read-only) */
  working_billing_claim?: WorkingBillingClaimResponse | null;
};
export type WorkingClaimLineItem2 = {
  /** Charge amount in cents (>= 0), if priced. */
  charge_cents?: number | null;
  /** Billing procedure code in '{SYSTEM}:{CODE}' form, SYSTEM = CPT or HCPCS (e.g. 'CPT:99214', 'HCPCS:H0031'); uppercased and validated. */
  code_id: string;
  /** Subset of the claim-level ICD-10 diagnosis_codes this line links to (CMS-1500 Box 24E). Empty = all claim diagnoses apply. */
  diagnosis_codes?: string[];
  /** Per-modifier provenance; keys must be a subset of modifiers. */
  modifier_sources?: {
    [key: string]:
      | "provider_selected"
      | "ai_recommended"
      | "structured"
      | "carried_forward";
  };
  /** CPT/HCPCS modifiers (max 4), uppercased and de-duplicated. */
  modifiers?: string[];
  /** Provenance of this line: 'provider_selected', 'ai_recommended', 'structured', or 'carried_forward'. */
  source:
    | "provider_selected"
    | "ai_recommended"
    | "structured"
    | "carried_forward";
  /** Billed units for this line (>= 1). */
  units?: number;
};
export type WorkingBillingClaimPutRequest2 = {
  /** Optional provenance for each diagnosis code. If omitted, all codes are marked provider_selected. */
  diagnosis_code_sources?: {
    [key: string]:
      | "provider_selected"
      | "ai_recommended"
      | "structured"
      | "carried_forward";
  } | null;
  /** ICD-10 diagnosis codes for the claim (max 4 after normalization) */
  diagnosis_codes?: string[];
  /** Optimistic concurrency token. If provided and stale, update returns 409. */
  expected_updated_at?: string | null;
  /** Full replacement list of claim line items */
  line_items?: WorkingClaimLineItem2[];
  /** CMS place of service code (e.g. '11', '02') */
  place_of_service?: string | null;
};
export type UploadDocumentResponse = {
  /** Stedi documentId to reference when completing the task */
  document_id: string;
};
export type UploadDocumentRequest = {
  /** MIME type of the file */
  content_type?: string;
  /** Base64-encoded file contents */
  data: string;
  /** Original file name, e.g. authorization.pdf */
  file_name: string;
};
export type CompleteTaskRequest = {
  /** Task field values: {key, value} for text fields, {key, documentId} for document fields */
  values?: {
    [key: string]: any;
  }[];
};
export type BillingAddressResponse3 = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type ServiceFacilityResponse = {
  address: BillingAddressResponse3;
  created_at: string;
  display_name: string;
  facility_npi: string | null;
  facility_other_id: string | null;
  is_default: boolean;
  organization_id: string;
  service_facility_id: string;
  updated_at: string;
};
export type ServiceFacilityListResponse = {
  service_facilities: ServiceFacilityResponse[];
};
export type BillingAddressResponse4 = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type ServiceFacilityResponse2 = {
  address: BillingAddressResponse4;
  created_at: string;
  display_name: string;
  facility_npi: string | null;
  facility_other_id: string | null;
  is_default: boolean;
  organization_id: string;
  service_facility_id: string;
  updated_at: string;
};
export type BillingAddressSchema2 = {
  city: string;
  line1: string;
  line2?: string | null;
  state: string;
  zip: string;
};
export type CreateServiceFacilityRequest = {
  address: BillingAddressSchema2;
  display_name: string;
  facility_npi?: string | null;
  facility_other_id?: string | null;
  is_default?: boolean;
};
export type ServiceFacilityDeleteResponse = {
  /** Whether deletion was successful */
  deleted: boolean;
};
export type BillingAddressUpdateSchema2 = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type UpdateServiceFacilityRequest = {
  address?: BillingAddressUpdateSchema2 | null;
  display_name?: string | null;
  facility_npi?: string | null;
  facility_other_id?: string | null;
  is_default?: boolean | null;
};
